import { HttpClient } from '@angular/common/http';
import { afterNextRender, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, ValidatorFn } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { map, startWith, debounceTime, tap } from 'rxjs/operators';
import { MainService } from '../shared/services/main.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from '../../environments/environment';
import { KeyValue } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { CustomDateAdapterTransfer } from '../datepicker-inline-calendar/custom-date-adapter-transfer';
import { TimepickerComponent } from '../timepicker/timepicker.component';

declare var google: any;

@Component({
  selector: 'app-booking-widget-transfer',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatRadioModule,
    MatCheckboxModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    TimepickerComponent
  ],
  templateUrl: './booking-widget-transfer.component.html',
  styleUrl: './booking-widget-transfer.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapterTransfer }],
})
export class BookingWidgetTransferComponent {
  @Input() external_channel: any;// variable venntur / tour2b
  @Input() api_url: any; // variable https://api.actividadesencanfranc.hub2b.travel
  @Input() channelactivitycode: any; // Variable ID PRODUCTO EN TOUR2B: 42
  @Input() productid: any; // Variable ID PRODUCTO EN B2C: 30
  @Input() isOpenDate: any; // Variable for musment activities (temporal finjo demencia)
  @Input() producttype: any; // Variable Activity
  @Input() web_city: any; // Variable Can Franc
  @Input() PUBLIC_KEY: any; // Variable: pk_test_cycICGEq4Nfma9OeiFOB2rmU00Lapr8BSK / pk_live_z31RtXGJKEPg0Q4EWzIBZfYr00pHmRWYkO
  @Input() lang: any; // Variable: es / en
  @Input() seller: any; // Variable: es / en
  @Input() connector: any; // Variable: es / en
  @Input() success_url: any;
  @Input() error_url: any;
  // @Input() WEB_TITLE: any; Variable 'Actividades En Can Franc'

  @Input() price: any;
  @Input() isCredit: any;
  @Input() isOnRequest: any;
  @Input() isActive: any;
  @Input() productTitle: any;
  @Input() daysToPayBeforeStay: any;
  @Input() release: any;
  @Input() queryParams: any;
  @Input() dateParams: any;

  @Output() sentData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('visibility') visibility: any;
  @ViewChild('addresstext', { static: false }) addresstext: any;

  @ViewChild('startTimeInput') startTimeEl!: ElementRef<HTMLInputElement>;
  @ViewChild('endDateInput') endDateEl!: ElementRef<HTMLInputElement>;
  @ViewChild('endTimeInput') endTimeEl!: ElementRef<HTMLInputElement>;

  currentStep: any = 0;
  currentRoute: string = '';
  mainLanguages = ['es', 'en', 'de'];
  language: string = 'es'; // Por defecto, el idioma es español
  startDate = new Date();
  bookingForm!: FormGroup;
  externalPaxDetailsForm!: FormGroup;
  isCalendarOpen = true;
  showPaymentForm = false;
  configuration: any;
  selectedModality: any;
  clientsRequested = 0;

  showHourSelection: boolean = false;
  // Availability
  productIsOnRequest: any;
  availableSchedules = <any>[];
  modalities: any = {};
  isOnTransferTime: any;
  isOnRelease: any;
  bookingDates: any;
  room: any = {
    adults: 2,
    kids: 0,
    babies: 0,
  };
  booking: any = { clientTypes: {} };
  showPaymentMethodForm: any;
  roomArray = [this.room];
  totalPriceCost: any = 0;
  totalPVD: number = 0;
  isPrebookingRequested = false;
  incompleteAlert: any;
  paxResume: any;
  countries: any;
  airlines: any;

  stripe: any;
  stripePromise: Promise<any> = Promise.resolve();
  elements: any;

  pickupScheduleInRadious: any;
  closestPickupSchedule: any;
  closestDistance = Infinity;
  selectedLatitude: any = null
  selectedLongitude: any = null
  bookingId: any;
  error: any;
  selectedIndex: number = -1;
  selectedScheduleIndex: number = -1;
  resumeModality: string = '';
  isCalendarDisabled = false;
  moreText = false;
  formattedClients = <any>[];
  isLoading = true;
  pickups: any;
  dynamic_form: any;

  isTooltipVisible = false;
  tooltipPosition = { x: 0, y: 0 };
  shadowRoot: any;

  totalClientTypesSelected: number = 0;
  // WEB_TITLE = 'Actividades En Can Franc'; variable
  // WEB_CITY = 'Can Franc'; variable
  paymentMethod: any;
  dynamicQuestions = <any>[];
  // dynamicQuestionsArray!: FormArray;

  isValidSeller = false;
  showInvalidSellerError = false;
  validActivity = false;
  validSeller = false;
  formattedActivityPrices = <any>[]
  pricing: any = {};
  partner: any;
  clientTypeList: string[] = [];
  paxControlList: any;

  dynamicApiUrl: any;
  tieneCamposAll: boolean = false;
  paxRules: any = {};
  loadingPaxDetails = false;

  refreshTick = 0;

  // nuevo
  selectedStartDate?: Date;
  selectedEndDate?: Date;
  selectedStartTime?: string; // 'HH:MM'
  selectedEndTime?: string;   // 'HH:MM'
  locations: any[] = []; // <-- mete aquí tu array (o pásalo por @Input)
  selectedPlaceAddress: any; // <-- mete aquí tu array (o pásalo por @Input)
  filteredLocations$!: Observable<any[]>;
  selectedTransfer: any;
  crossSelling: any = {};

  originLocations: any;
  originDropdown: any;

  showOriginAirport = false;

  showOutwardOriginAirlineCode = false;
  showOutwardDestinationAirlineCode = false;
  showReturnOriginAirlineCode = false;
  showReturnDestinationAirlineCode = false;

  showStartHourList = false;
  selectedStartHour: any;
  showStartMinuteList = false;
  selectedStartMinute: any;

  showEndHourList = false;
  selectedEndHour: any;
  showEndMinuteList = false;
  selectedEndMinute: any;

  showArrivalCalendar = false;
  showReturnCalendar = false;
  showPaxSelector = false;
  openedModalityIndex: any;
  selectedOrigin: any;
  totalServicesAddition = 0;
  openAddExtrasModal = false;
  openLoadingModal = false;
  loadingModalText = '';
  showMoreInfo = false;
  openDetailsCollapsible = false;

  translationUrl = environment.translationUrl;
  showTransferData = false;
  filteredOutwardAirlines$: Observable<{ name: string, iata: string }[]>[] = [];
  filteredReturnAirlines$: Observable<{ name: string, iata: string }[]>[] = [];

  isMobile$: Observable<boolean>;
  invertedInputs = false;

  showCountryCodes = false;
  countriesToShow: any;

  calendarMonths: Date[] = [];
  endCalendarMonths: Date[] = [];

  isLoadingTransfers = false;
  trackByMonth = (_: number, d: Date) => d.getFullYear() * 100 + d.getMonth();

  private pendingStartTime?: string;
  private pendingEndTime?: string;

  // Validation
  showMissingPassengersAlert: boolean = false;
  showMissingLocationOriginAlert: boolean = false;
  showMissingDestinationAlert: boolean = false;
  showMissingStartDateAlert: boolean = false;
  showMissingStartTimeAlert: boolean = false;
  showMissingEndTimeAlert: boolean = false;
  showErrorModal: boolean = false;
  errorModalMessage: any;

  labelMap: any;
  autocompleteFlag: boolean = false;

  constructor(private renderer: Renderer2, private router: Router, private fb: FormBuilder, private mainService: MainService, private http: HttpClient, public translateService: TranslateService, private elementRef: ElementRef, private cdr: ChangeDetectorRef, private breakpointObserver: BreakpointObserver, private location: Location, private dateAdapter: DateAdapter<Date>) {
    // this.stripePromise = loadStripe(this.PUBLIC_KEY);
    this.injectBootstrap();

    afterNextRender(() => {
      setTimeout(() => {
        this.dynamicApiUrl = this.connector != 'hub2b' ? this.api_url : 'https://api.' + this.external_channel + environment.hub2bEnv;
        this.translateService.setDefaultLang(this.lang);
        this.translateService.use(this.lang);
        this.translateService.get([
          'product.airlineCode',
          'product.flightNumber',
          'product.airportCode',
          'product.flightDateTime',
          'product.pickupDateTime',
          'product.location',
          'product.address',
          'product.hotelId',
          'product.googlePlaceId',
          'product.cruiseLine',
          'product.shipName',
          'product.cruiseTerminal',
          'product.shipDateTime',
          'product.trainNumber',
          'product.trainDateTime',
        ]).subscribe(t => {
          this.labelMap = {
            airline_code: t['product.airlineCode'],
            flight_number: t['product.flightNumber'],
            airport_code: t['product.airportCode'],
            flight_date_time: t['product.flightDateTime'],
            pickup_date_time: t['product.pickupDateTime'],
            name: t['product.location'],
            address: t['product.address'],
            hotel_id: t['product.hotelId'],
            google_place_id: t['product.googlePlaceId'],
            cruise_line: t['product.cruiseLine'],
            ship_name: t['product.shipName'],
            cruise_terminal: t['product.cruiseTerminal'],
            ship_date_time: t['product.shipDateTime'],
            train_number: t['product.trainNumber'],
            train_date_time: t['product.trainDateTime'],
          };
        });
        if (!this.partner) {
          if (this.seller) {
            this.mainService.getByParameter(this.api_url, 'sellers.id', this.seller, 'partners', this.lang).subscribe(partner => {
              partner = partner['hydra:member'][0];

              this.pricing = partner.pricing;
              this.partner = partner;
              this.mainService.getByParameter(this.api_url, 'partner.id', partner.id, 'configurations', this.lang).subscribe(resp => {
                if (resp['hydra:member'].length > 0) {
                  resp = resp['hydra:member'][0];
                  this.configuration = resp;
                  // if (this.configuration.paymentGatewayPublicKey) {
                  //   this.stripePromise = loadStripe(this.configuration.paymentGatewayPublicKey);
                  //   // Load Stripe for widget
                  //   this.stripePromise.then(stripe => {
                  //     this.stripe = stripe;
                  //     if (this.stripe) {
                  //       console.log('Stripe cargado correctamente');
                  //     } else {
                  //       console.error('Error al cargar Stripe');
                  //     }
                  //   });
                  // }
                  localStorage.setItem('configuration', JSON.stringify(resp));
                  // this.setColors(resp.mainColor, resp.secondaryColor);
                } else {
                  this.mainService.getFirst(this.api_url, 'configurations', this.lang).subscribe(resp => {
                    resp = resp['hydra:member'][0];
                    this.configuration = resp;
                    localStorage.setItem('configuration', JSON.stringify(resp));
                    // this.setColors(resp.mainColor, resp.secondaryColor);
                  })
                }

              })
            })
          }
          else {
            if (this.api_url) {
              let partnerSlug = this.api_url.split('.')[1];
              this.mainService.getByParameter(this.dynamicApiUrl, 'slug', partnerSlug, 'partners', this.lang).subscribe(partner => {
                partner = partner['hydra:member'][0];
                if (partner) {
                  this.pricing = partner.pricing;
                  this.partner = partner;
                  this.seller = partner.sellers[0].id;
                }
              })
              this.mainService.getFirst(this.api_url, 'configurations', this.lang).subscribe(resp => {
                resp = resp['hydra:member'][0];
                this.configuration = resp;
                // if (this.configuration.paymentGatewayPublicKey) {
                //   this.stripePromise = loadStripe(this.configuration.paymentGatewayPublicKey);
                //   // Load Stripe for widget
                //   this.stripePromise.then(stripe => {
                //     this.stripe = stripe;
                //     if (this.stripe) {
                //       console.log('Stripe cargado correctamente');
                //     } else {
                //       console.error('Error al cargar Stripe');
                //     }
                //   });
                // }
                localStorage.setItem('configuration', JSON.stringify(resp));
                // this.setColors(resp.mainColor, resp.secondaryColor);
              })
            }
          }
        }

      }, 1000);
    })
    this.isMobile$ = this.breakpointObserver
      .observe(['(max-width: 931px)'])
      .pipe(map(result => result.matches));
  };

  // nuevo

  /* -------- getters para los inputs -------- */
  private sameDay(a?: Date | string | null, b?: Date | string | null): boolean {
    if (!a || !b) return false;
    const da = new Date(a); da.setHours(0, 0, 0, 0);
    const db = new Date(b); db.setHours(0, 0, 0, 0);
    return da.getTime() === db.getTime();
  }

  get endMinTime(): string | null {
    // Si no hay endDate o no hay startDate -> sin límite
    if (!this.selectedEndDate || !this.selectedStartDate) return null;

    // Si no es el mismo día -> sin límite
    if (!this.sameDay(this.selectedStartDate, this.selectedEndDate)) return null;

    // Necesitamos startHour/startMinute (strings "HH" y "mm")
    if (!this.selectedStartHour || !this.selectedStartMinute) return null;

    const sh = Number(this.selectedStartHour);
    const sm = Number(this.selectedStartMinute);

    if (!Number.isFinite(sh) || !Number.isFinite(sm)) return null;

    // Regla A: mínimo start + 1 hora (manteniendo los minutos)
    const minTotal = sh * 60 + sm + 60;

    // Si start era 23:xx => minTotal >= 1440 => no hay horas válidas ese día
    if (minTotal >= 24 * 60) return null;

    const hh = String(Math.floor(minTotal / 60)).padStart(2, '0');
    const mm = String(minTotal % 60).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  get routeLabel(): string {
    const origin = this.bookingForm.get('locationOriginFormatted')?.value;
    const dest = this.bookingForm.get('locationDestination')?.value;

    const forward = this.invertedInputs
      ? [dest, origin]
      : [origin, dest];

    const outward = forward.filter(Boolean).join(' > ');

    if (!this.selectedEndDate) {
      return outward;
    }

    const returnTrip = [...forward].reverse().filter(Boolean).join(' > ');

    return outward + '\n' + returnTrip;
  }

  /* -------- utilidades -------- */
  toISODate(d: any): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  private isToday(d?: Date | string | null): boolean {
    if (!d) return false;
    const day = new Date(d); day.setHours(0, 0, 0, 0);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    return day.getTime() === today.getTime();
  }

  private isSameDay(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  }

  private toLocalISO(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
  }
  formatCustomDate(d: any): string {
    if (!(d instanceof Date) || isNaN(d.getTime())) {
      return '';
    }
    // Mes abreviado en inglés
    const month = d.toLocaleString('en-US', { month: 'short' }); // "Sep"
    // Día del mes
    const day = d.getDate(); // 17
    return `${month} ${day}`;
  }

  get startDateTimeISO(): string | undefined {
    if (!this.selectedStartDate) return;

    const d = new Date(this.selectedStartDate);

    const hour = this.selectedStartHour || '00';
    const minute = this.selectedStartMinute || '00';

    d.setHours(parseInt(hour, 10), parseInt(minute, 10), 0, 0);
    return this.toLocalISO(d);
  }

  get endDateTimeISO(): string | undefined {
    if (!this.selectedEndDate) return;

    const d = new Date(this.selectedEndDate);

    const hour = this.selectedEndHour || '00';
    const minute = this.selectedEndMinute || '00';

    d.setHours(parseInt(hour, 10), parseInt(minute, 10), 0, 0);
    return this.toLocalISO(d);
  }

  private openPicker(input?: HTMLInputElement) {
    if (!input) return;
    // try native showPicker()
    if (typeof (input as any).showPicker === 'function') {
      (input as any).showPicker();
    } else {
      input.focus();
      setTimeout(() => input.click(), 0); // fallback
    }
  }

  // muestra el texto en el input cuando el valor es un objeto
  displayLocation = (loc?: any | string): string =>
    typeof loc === 'string' ? loc : (loc ? this.getLabel(loc) : '');

  // cómo sacar el “nombre” de cualquier shape
  getLabel = (loc: any): string =>
    (loc.name || loc.title || loc.label || '').toString() + ' (' + loc.code + ')';

  // filtrado (case-insensitive) + límite de sugerencias
  private filterLocations(query: string): any[] {
    const q = (query || '').trim().toLowerCase();
    // Slice hasta 10 ubicaciones máx? -> .slice(0, 10)
    if (!q) return this.locations;
    return this.locations.filter(l => this.getLabel(l).toLowerCase().includes(q)).slice(0, 10);
  }

  onDatalistInput(e: Event) {
    const val = (e.target as HTMLInputElement).value.toLowerCase();
    const hit = this.locations.find(l => this.getLabel(l).toLowerCase() === val);
    if (hit) this.bookingForm.get('ubication')?.setValue(hit); // guarda el objeto
  }

  search() {
    this.showArrivalCalendar = false;
    this.showReturnCalendar = false;
    this.isLoadingTransfers = true;
    if (!this.bookingForm.get('locationOriginFormatted')?.value) {
      // Falta origen
      this.showMissingLocationOriginAlert = true;
      setTimeout(() => this.showMissingLocationOriginAlert = false, 5000);
      this.isLoadingTransfers = false;
    } else if (!this.bookingForm.get('locationDestination')?.value) {
      // Falta destino
      this.showMissingDestinationAlert = true;
      setTimeout(() => this.showMissingDestinationAlert = false, 5000);
      this.isLoadingTransfers = false;
    } else if (this.showPaxSelector) {
      // Faltan PAX
      this.showMissingPassengersAlert = true;
      setTimeout(() => this.showMissingPassengersAlert = false, 5000);
      this.isLoadingTransfers = false;
    } else if (!this.selectedStartDate) {
      // Falta fecha de salida
      this.showArrivalCalendar = false;
      this.showMissingStartDateAlert = true;
      setTimeout(() => this.showMissingStartDateAlert = false, 5000);
      this.isLoadingTransfers = false;
    } else {
      // Realizamos búsqueda si hay día de inicio y hora de inicio
      // O
      // Si hay día de inicio, hora de inicio, día de fin y hora de fin
      if ((this.selectedStartDate && this.selectedStartHour && this.selectedStartMinute && !this.selectedEndDate && !this.selectedEndHour && !this.selectedEndMinute) || (
        this.selectedStartDate &&
        this.selectedStartHour &&
        this.selectedStartMinute &&
        this.selectedEndDate &&
        this.selectedEndHour &&
        this.selectedEndMinute
      )) {
        let data: any = {
          "exchangeCurrency": ["EUR"],
          "currency": "EUR",
          "origin": !this.invertedInputs ? ("location:" + this.bookingForm.get('locationOrigin')?.value) : ("coords:" + this.bookingForm.get('locationDestinationLatitude')?.value + ',' + this.bookingForm.get('locationDestinationLongitude')?.value),
          "destination": !this.invertedInputs ? ("coords:" + this.bookingForm.get('locationDestinationLatitude')?.value + ',' + this.bookingForm.get('locationDestinationLongitude')?.value) : ("location:" + this.bookingForm.get('locationOrigin')?.value),
          "passengers": this.bookingForm.get('adults')?.value + ',' + this.bookingForm.get('kids')?.value + ',' + this.bookingForm.get('infants')?.value,
          "outwardDate": this.startDateTimeISO,
        }
        if (this.endDateTimeISO) {
          data["returnDate"] = this.endDateTimeISO;
        }
        this.mainService.postConnectionTransfers(this.connector, this.external_channel, `quotes`, data).subscribe((resp: any) => {
          window.scrollTo(0, 0);
          this.currentStep = 1;
          resp.quotes.sort((a: any, b: any) => a.price.value - b.price.value);
          this.modalities = resp;
          this.crossSelling = resp?.cross_selling ?? {};
          // opcional: resetear seleccionados al cambiar de quote
          this.bookingForm.patchValue({ sms: false, gold_protection: false }, { emitEvent: false });

          // Comprimir buscador
          this.showArrivalCalendar = false;
          this.showReturnCalendar = false;
          this.showPaxSelector = false;

          // Ocultar spinner
          this.isLoadingTransfers = false;
        }, (error: any) => {
          if (error.status == 404) {
            this.errorModalMessage = this.translateService.instant('error.unavailableRoute');
            this.isLoadingTransfers = false;
            this.currentStep = 0;
          } else if (error.status == 400) {
            this.errorModalMessage = this.translateService.instant('error.unavailableDestination');
            this.isLoadingTransfers = false;
            this.currentStep = 0;
          } else {
            this.errorModalMessage = this.translateService.instant('error.default');
            this.isLoadingTransfers = false;
            this.currentStep = 0;
          }
          this.showErrorModal = true;
          setTimeout(() => this.showErrorModal = false, 15000);
        })
      } else {
        // Faltan campos en fechas y horas
        console.log("Control de errores - Faltan campos en fechas y horas");
        if (this.selectedStartDate && (!this.selectedStartHour || !this.selectedStartMinute)) {
          console.log('seleccionada fecha de inicio pero no hora de inicio')
          this.showMissingStartTimeAlert = true;
          setTimeout(() => this.showMissingStartTimeAlert = false, 5000);
        } else if (this.selectedEndDate && (!this.selectedEndHour || !this.selectedEndMinute)) {
          console.log('seleccionada fecha de fin pero no hora de fin')
          this.showMissingEndTimeAlert = true;
          setTimeout(() => this.showMissingEndTimeAlert = false, 5000);
        }
        this.isLoadingTransfers = false;
      }
    }
  }

  shouldDisable(): boolean {
    // Caso 1:
    // Hay día de inicio y hora de inicio → false
    if (this.selectedStartDate && this.selectedStartHour && this.selectedStartMinute && !this.selectedEndDate && !this.selectedEndHour && !this.selectedEndMinute) {
      return false;
    }

    // Caso 2:
    // Hay día de fin, día de inicio, hora de inicio y hora de fin → false
    if (
      this.selectedStartDate &&
      this.selectedStartHour &&
      this.selectedStartMinute &&
      this.selectedEndDate &&
      this.selectedEndHour &&
      this.selectedEndMinute
    ) {
      return false;
    }

    // En cualquier otro caso, true
    return true;
  }

  changeAdults(event: any) {
    this.bookingForm.get('adults')?.setValue(event.target.value);
  }

  changeKids(event: any) {
    this.bookingForm.get('kids')?.setValue(event.target.value);
  }

  changeInfants(event: any) {
    this.bookingForm.get('infants')?.setValue(event.target.value);
  }

  selectedTransferEvent(modality: any, index: any) {
    this.selectedTransfer = modality;
    this.currentStep = 2;
    this.scrollIntoView("step4");
    this.selectedIndex = index;
    // this.nextStep()
    // this.setExtrasFromModality(modality?.extras || modality?.additional_items || []);
  }

  map: Record<string, 'flight' | 'train' | 'cruise'> = {
    airport: 'flight',
    train_station: 'train',
    sea_port: 'cruise',
  };

  // --- helper: si no está mapeado → accommodation
  private getTransferType(subtype?: string): 'flight' | 'train' | 'cruise' | 'accommodation' {
    return this.map[(subtype ?? '').toLowerCase()] ?? 'accommodation';
  }

  // --- validador: obliga a que al menos uno de los campos tenga valor
  private requireOneOf(keys: string[]): ValidatorFn {
    return (group: AbstractControl) => {
      if (!(group instanceof FormGroup)) return null;
      const hasOne = keys.some(k => {
        const v = group.get(k)?.value;
        return v !== null && v !== undefined && String(v).trim() !== '';
      });
      return hasOne ? null : { requireOneOf: keys };
    };
  }

  // --- builders por tipo
  private buildFlightGroup(loc?: any, date?: any, type?: any): FormGroup {
    const g: any = {
      airline_code: ['', Validators.required],
      // flight_number: ['', Validators.required],
      airport_code: [{ value: loc?.code ?? '', disabled: true }, Validators.required],
      flight_date_time: [{ value: date ?? '', disabled: true }, Validators.required],
      flight_number: ['', Validators.required]

      // pickup_date_time: [''],
    }

    // if (type == 'origin') {
    // }

    return this.fb.group(g);
  }

  private buildAccommodationGroup(loc?: any, date?: any, type?: any): FormGroup {
    const g: any = {
      name: [{ value: this.bookingForm.controls['ubication'].value ?? '', disabled: true }],
      address: [this.selectedPlaceAddress ?? '', Validators.required],
      // pickup_date_time: [''],
      // hotel_id: [null],
      // google_place_id: [''],
    }

    date = new Date(date);
    date.setMinutes(date.getMinutes() - 150 - this.selectedModality.minutes);

    if (type === 'origin') {
      g.pickup_date_time = [
        {
          value: date.toLocaleString('sv-SE').replace(' ', 'T'),
          disabled: true
        },
        Validators.required
      ];
    }

    return this.fb.group(g);
  }

  private buildCruiseGroup(loc?: any, date?: any, type?: any): FormGroup {
    return this.fb.group({
      cruise_line: ['', Validators.required],
      ship_name: ['', Validators.required],
      cruise_terminal: ['', Validators.required],
      ship_date_time: [date ?? '', Validators.required],
      // pickup_date_time: [''],
    });
  }

  private buildTrainGroup(loc?: any, date?: any, type?: any): FormGroup {
    return this.fb.group({
      train_number: ['', Validators.required],
      train_date_time: [date ?? '', Validators.required],
      // pickup_date_time: [''],
    });
  }

  // --- fábrica según tipo
  private buildGroupByType(type: 'flight' | 'train' | 'cruise' | 'accommodation', loc?: any, defISO?: any, direction?: any): FormGroup {
    switch (type) {
      case 'flight': return this.buildFlightGroup(loc, defISO, direction);
      case 'train': return this.buildTrainGroup(loc, defISO, direction);
      case 'cruise': return this.buildCruiseGroup(loc, defISO, direction);
      default /*accommodation*/: return this.buildAccommodationGroup(loc, defISO, direction);
    }
  }

  private buildContactPax(): FormGroup {
    return this.fb.group({
      title: [null, Validators.required],
      name: [null, [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
      surname: [null, [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
      countryCode: ['ES', Validators.required],
      phone: [null, [Validators.required, Validators.pattern(/^[0-9\s\-().]{6,20}$/)]],
      email: [null, [Validators.required, Validators.email]],
    });
  }

  private buildExtraGroup(extra: any): FormGroup {
    return this.fb.group({
      code: [extra.code],
      description: [extra.description],
      unit_price: [Number(extra.unitary_price?.value ?? 0)],
      currency: [extra.unitary_price?.currency ?? 'EUR'],
      prefix: [extra.unitary_price?.prefix_symbol ?? ''],
      suffix: [extra.unitary_price?.suffix_symbol ?? '€'],
      max: [extra.max_quantity],
      quantity: [0, [
        Validators.min(0),
        Validators.max(extra.max_quantity),
        Validators.pattern(/^\d+$/)  // entero
      ]],
    });
  }

  private buildExtrasArray(extras: any[] = []): FormArray {
    return this.fb.array(
      (extras || []).map(x => this.buildExtraGroup(x))
    );
  }

  /** Payload para backend: solo los que qty>0 */
  buildExtrasPayload(): { code: string; quantity: number }[] {
    return (this.extrasFA?.value || [])
      .filter((x: any) => Number(x.quantity) > 0)
      .map((x: any) => ({ code: x.code, quantity: Number(x.quantity) }));
  }

  private buildLegGroup(originLoc: any, destinationLoc: any, defISO = ''): FormGroup {
    const oType = this.getTransferType(originLoc?.subtype);
    const dType = this.getTransferType(destinationLoc?.subtype);

    return this.fb.group({
      origin: this.buildGroupByType(oType, originLoc, defISO, "origin"),
      destination: this.buildGroupByType(dType, destinationLoc, defISO, "destination"),
      extras: this.buildExtrasArray(this.selectedTransfer?.extras || [])
    });
  }

  get extrasFA(): FormArray {
    return this.outwardLegG?.get('extras') as FormArray;
  }

  get extrasReturnFA(): FormArray {
    return this.returnLegG?.get('extras') as FormArray;
  }

  get paxFormArrayTransfer(): FormArray {
    return this.bookingForm.get('pax') as FormArray;
  }

  get outwardFA(): any {
    return this.bookingForm.get('outward') as FormArray;
  }

  get returnFA(): any {
    return this.bookingForm.get('return') as FormArray;
  }

  get outwardLegG(): FormGroup | null {
    return (this.outwardFA?.length ? this.outwardFA.at(0) : null) as FormGroup | null;
  }

  get returnLegG(): FormGroup | null {
    return (this.returnFA?.length ? this.returnFA.at(0) : null) as FormGroup | null;
  }

  /** Total € de extras seleccionados */
  get extrasTotal(): number {
    return (this.extrasFA?.controls || []).reduce((sum, g) => {
      const price = Number(g.get('unit_price')?.value || 0);
      const qty = Number(g.get('quantity')?.value || 0);
      return sum + price * qty;
    }, 0) + (this.extrasReturnFA?.controls || []).reduce((sum, g) => {
      const price = Number(g.get('unit_price')?.value || 0);
      const qty = Number(g.get('quantity')?.value || 0);
      return sum + price * qty;
    }, 0);
  }

  // Busca en la VUELTA el grupo del extra por 'code'
  private findReturnExtraGroupByCode(code?: string): FormGroup | null {
    if (!code || !this.returnLegG) return null;
    const ret = this.returnLegG.get('extras') as FormArray;
    if (!ret) return null;
    for (let i = 0; i < ret.length; i++) {
      const g = ret.at(i) as FormGroup;
      if (g.get('code')?.value === code) return g;
    }
    return null;
  }

  // Devuelve el control 'quantity' de la VUELTA (para bindearlo en el input)
  getReturnQuantityCtrlByCode(code?: string): AbstractControl | null {
    return this.findReturnExtraGroupByCode(code)?.get('quantity') ?? null;
  }

  // Máximo permitido en la VUELTA (por estética del [max])
  getReturnMaxByCode(code?: string): number | null {
    const g = this.findReturnExtraGroupByCode(code);
    return g ? (g.get('max')?.value ?? null) : null;
  }

  isDateTimeField = (key: string) => key.endsWith('_date_time');

  // (opcional) pinta * si es required
  isRequired(ctrl: AbstractControl | null | undefined): boolean {
    // Angular 14+ tiene hasValidator; si no, devuelve true y ya
    return (ctrl as any)?.hasValidator?.(Validators.required) ?? true;
  }

  goBack() { this.location.back(); }

  entriesOf(group: FormGroup): { key: string; ctrl: AbstractControl }[] {
    return Object.entries(group.controls).map(([key, ctrl]) => ({ key, ctrl }));
  }

  // --- tu función principal
  setPaxFormTransfer() {
    const outwardFA = this.bookingForm.get('outward') as FormArray;
    const returnFA = this.bookingForm.get('return') as FormArray;
    outwardFA.clear();
    returnFA.clear();

    const origin = this.selectedOrigin       // {subtype, code, name, ...}
    const destination = this.bookingForm.get('locationDestination')?.value;

    // Necesitamos ambos para montar un leg
    if (origin && destination) {
      // OUTWARD: origin -> destination (prefillo con start)
      outwardFA.push(this.buildLegGroup(origin, destination, (!this.invertedInputs ? this.startDateTimeISO : this.endDateTimeISO) ?? ''));

      // RETURN (si tienes end date/time): destination -> origin
      if (this.endDateTimeISO || this.invertedInputs) {
        returnFA.push(this.buildLegGroup(destination, origin, (!this.invertedInputs ? this.endDateTimeISO : this.startDateTimeISO) ?? ''));
      }
    }

    // Pax contacto (solo 1)
    const fa = this.paxFormArrayTransfer; // tu getter
    fa.clear();
    fa.push(this.buildContactPax());

    // Sincroniza nombre completo + email del pax[0] -> raíz
    this.syncFormFields?.(0);
    this.initOutwardControls();
  }

  setExtrasFromModality(extras: any[] = []) {
    // crea el array 'extras' si no existe
    if (!this.bookingForm.get('extras')) {
      this.bookingForm.addControl('extras', this.fb.array([]));
    }
    this.extrasFA.clear();
    (extras || []).forEach(x => this.extrasFA.push(this.buildExtraGroup(x)));
    (extras || []).forEach(x => this.extrasReturnFA.push(this.buildExtraGroup(x)));
  }

  // 👉 helper para mostrar el precio bonito
  formatPrice(p?: any): string {
    if (!p) return '—';
    const val = Number(p.value || 0).toFixed(2);
    // si trae prefijo/sufijo los usamos; sino, cae en la divisa
    const prefix = p.prefix_symbol || '';
    const suffix = p.suffix_symbol || '';
    return prefix ? `${prefix}${val}` : suffix ? `${val} ${suffix}` : `${val} ${p.currency || ''}`;
  }

  // 💰 total solo de cross-selling
  get crossSellingTotal(): number {
    const v = this.bookingForm.value;
    let total = 0;
    if (v.sms) total += Number(this.crossSelling.sms?.price?.value || 0);
    if (v.gold_protection) total += Number(this.crossSelling.gold_protection?.price?.value || 0);
    return total;
  }

  // 💰 total global (extras + cross)
  get addOnsTotal(): number {
    return this.extrasTotal + this.crossSellingTotal;
  }


  logInvalidControls(form: AbstractControl, path: string = '') {
    if (form instanceof FormGroup) {
      Object.entries(form.controls).forEach(([key, ctrl]) => {
        this.logInvalidControls(ctrl, path ? `${path}.${key}` : key);
      });
    } else if (form instanceof FormArray) {
      form.controls.forEach((ctrl, i) => {
        this.logInvalidControls(ctrl, `${path}[${i}]`);
      });
    } else if (form instanceof FormControl) {
      if (form.invalid) {
        console.warn(
          `❌ Invalid control: ${path}`,
          'value:', form.value,
          'errors:', form.errors
        );
      }
    }
  }


  get hasReturn(): boolean { return this.returnFA?.length > 0; }

  get canAddReturn(): boolean {
    const origin = this.bookingForm.get('locationOrigin')?.value;
    const destination = this.bookingForm.get('locationDestination')?.value;
    return !!(origin && destination);
  }

  // min para el <input type="datetime-local"> de la vuelta
  get minReturnISO(): string {
    // mínimo = start (fecha y hora si la tienes) o ahora
    const base = this.selectedStartDate ? new Date(this.selectedStartDate) : new Date();
    if (this.selectedStartTime) {
      const [h, m] = this.selectedStartTime.split(':').map(Number);
      base.setHours(h || 0, m || 0, 0, 0);
    } else if (!this.selectedStartDate) {
      // si no hay start date, mínimo ahora
      const now = new Date();
      base.setHours(now.getHours(), now.getMinutes(), 0, 0);
    } else {
      base.setHours(0, 0, 0, 0);
    }
    return this.toLocalISO(base); // YYYY-MM-DDTHH:mm
  }

  returnDraftISO = ''

  onReturnDraftChange(e: Event) {
    this.returnDraftISO = (e.target as HTMLInputElement).value; // 'YYYY-MM-DDTHH:mm'
  }

  private toMinutes(iso?: string): string { return iso ? iso.slice(0, 16) : ''; }

  addReturnLeg(isoFromUI?: string) {
    if (!this.canAddReturn) return;
    const origin = this.bookingForm.get('locationOrigin')?.value;
    const destination = this.bookingForm.get('locationDestination')?.value;

    // preferimos: lo que el user eligió aquí > endDateTime > vacío
    const defISO = this.toMinutes(isoFromUI || this.endDateTimeISO || '');

    // VUELTA = destination -> origin
    const leg = this.buildLegGroup(destination, origin, defISO);
    this.returnFA.push(leg);

    // si el user eligió aquí la fecha y no tenías global endDateTime, sincronízala
    if (!this.endDateTimeISO && defISO) {
      const [datePart, timePart] = defISO.split('T');
      if (datePart) {
        const [y, m, d] = datePart.split('-').map(Number);
        this.selectedEndDate = new Date(y, m - 1, d);
      }
      if (timePart) this.selectedEndTime = timePart.slice(0, 5);
    }

    this.returnDraftISO = '';
  }

  removeReturnLeg(index = 0) {
    if (!this.hasReturn) return;
    this.returnFA.removeAt(index);
  }

  /** Para editar “la fecha principal” de la vuelta con un único input */
  getReturnDateCtrl(i: number): AbstractControl | null {
    const leg = this.returnFA.at(i) as FormGroup;
    const dest = leg.get('destination') as FormGroup;
    const orig = leg.get('origin') as FormGroup;
    const keys = ['flight_date_time', 'train_date_time', 'ship_date_time', 'pickup_date_time'];
    for (const k of keys) {
      const c = dest.get(k) || orig.get(k);
      if (c) return c;
    }
    return null;
  }

  keepOrder = (a: KeyValue<string, unknown>, b: KeyValue<string, unknown>) => 0; // no reordenar
  trackByKey = (_: number, item: KeyValue<string, unknown>) => item.key;

  getTotalPaxTransfer() {
    return parseInt(this.bookingForm.get('adults')?.value)
      + parseInt(this.bookingForm.get('infants')?.value)
      + parseInt(this.bookingForm.get('kids')?.value)
  }

  genAges = (counts: any, dates: any) => {
    const arr = Array.isArray(dates) ? dates : [dates];
    const last = new Date(Math.max(...arr.map(d => +new Date(d))));
    const mk = (yrs: any, n: any) =>
      Array.from({ length: n || 0 }, () => ({
        birthday: new Date(Date.UTC(
          last.getUTCFullYear() - yrs, last.getUTCMonth(), last.getUTCDate()
        )).toISOString().slice(0, 10)
      }));
    return [...mk(1, counts.infants), ...mk(3, counts.kids)];
  };

  // a partir de aqui viejo

  ngOnChanges(changes: SimpleChanges) {
    if ('lang' in changes) {
      const locale = this.mapLangToLocale(this.lang);
      this.dateAdapter.setLocale(locale);
    }
    if (!this.isOnRequest) {
      if (this.PUBLIC_KEY && !this.stripe) {
        this.stripePromise = loadStripe(this.PUBLIC_KEY);
        // Load Stripe for widget
        this.stripePromise.then(stripe => {
          this.stripe = stripe;
          if (this.stripe) {
            console.log('Stripe cargado correctamente');
          } else {
            console.error('Error al cargar Stripe');
          }
        });
      } else {
        console.warn('Por favor, introduzca una clave pública de Stripe.')
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainService.getConnectionTransfers(this.connector, this.external_channel, `gateways?locale=${this.lang}`, {}).subscribe(results => {
        this.locations = results.gateways;
        this.getPlaceAutocomplete();
      })
      this.loadListeners(false);
    }, 1000);
  }

  loadListeners(fromBack: boolean) {
    setTimeout(() => {
      const inputs = this.shadowRoot.querySelectorAll('.js_form-input');
      inputs.forEach((input: any) => {
        input.addEventListener('blur', (event: any) => {
          if (event.target.value.length) {
            event.target.classList.add("full");
          } else {
            event.target.classList.remove("full");
          }
        });
        fromBack ? input.classList.add("full") : null;
      })
    }, 500);
  }

  private mapLangToLocale(lang: any): string {
    const l = (lang ?? '').toString().toLowerCase();
    // ajustar si hay mas idiomas
    if (l.startsWith('en')) return 'en-GB';
    return 'es-ES';
  }

  @HostListener('document:keydown.escape')
  closeOnEscape() {
    this.showStartHourList = false;
    this.showEndHourList = false;
    this.showStartMinuteList = false;
    this.showEndMinuteList = false;
  }

  @HostListener('document:click')
  closeOnOutsideClick() {
    this.showStartHourList = false;
    this.showEndHourList = false;
    this.showStartMinuteList = false;
    this.showEndMinuteList = false;
  }

  ngOnInit() {
    this.bookingForm = this.fb.group({
      hotel: [null],
      observations: [null],
      dynamicQuestions: this.fb.array([]),
      conditions: [true, Validators.required],
      newsletter: [false],
      coupon: [null],
      date: [this.startDate],
      pickupSchedule: [],
      ubication: [''],
      checkIn: [],
      checkOut: [],
      sellerCode: [''],
      pax: this.fb.array([]),
      adults: [2],
      kids: [0],
      infants: [0],


      // title: [null, Validators.required],
      name: [null, Validators.required],
      // surname: [null, Validators.required],
      countryCode: ['+34', [
        Validators.required,
        Validators.pattern(/^\+\d{1,4}$/)
      ]],
      phone: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      locationOriginFormatted: [''],
      locationOrigin: [''],
      locationDestination: [''],
      locationDestinationLatitude: [''],
      locationDestinationLongitude: [''],
      outward: this.fb.array([]),
      return: this.fb.array([]),
      destination: this.fb.array([]),
      extras: this.fb.array([]),
      sms: false,
      gold_protection: false,
    })
    // Obtener la ruta actual al inicio y suscribirse a cambios en la ruta
    this.currentRoute = this.router.url;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });

    this.http.get<any>(environment.translationUrl + 'assets/json/country_codes.json')
      .subscribe((countries: any) => {
        this.countries = countries;
      })

    this.http.get<any>(environment.translationUrl + 'assets/json/airline_codes.json')
      .subscribe((airlines: any) => {
        this.airlines = airlines;
      })

    const ctrl = this.bookingForm.get('locationOriginFormatted')!;
    this.filteredLocations$ = ctrl.valueChanges.pipe(
      startWith(''),
      debounceTime(120),
      tap(() => this.showOriginAirport = true),
      map(v => typeof v === 'string' ? v : this.getLabel(v)),
      map(txt => this.filterLocations(txt))
    );
    this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
    this.shadowRoot.addEventListener('pointerdown', (event: PointerEvent) => this.onShadowClick(event));

    document.documentElement.style.setProperty('--mdc-outlined-text-field-error-outline-color', "#DDDDDD");
    // document.documentElement.style.setProperty('--mdc-outlined-text-field-error-focus-outline-color', "#DDDDDD");
    this.generateCalendarMonths(12);
    this.rebuildEndCalendarMonths();
  }

  get name() { return this.bookingForm.get('name'); }
  get email() { return this.bookingForm.get('email'); }
  get countryCode() { return this.bookingForm.get('countryCode'); }
  get phone() { return this.bookingForm.get('phone'); }
  get message() { return this.bookingForm.get('message'); }
  get privacy() { return this.bookingForm.get('privacy'); }
  get dynamicQuestionsArray(): FormArray {
    return this.bookingForm.get('dynamicQuestions') as FormArray;
  }


  async nextStep(e: any) {
    e.stopPropagation();

    setTimeout(async () => {
      if (this.currentStep == 1) {
        if (this.totalServicesAddition == 0) {
          if (this.extrasFA.controls.length > 0) {
            this.openAddExtrasModalFunction()
          } else {
            this.closeAddExtrasModalFunction(false)
          }
        } else {
          this.loadingModalText = this.translateService.instant('product.processing');
          this.openLoadingModal = true;
          document.body.style.overflow = 'hidden';

          this.shadowRoot.getElementById("booking").scrollIntoView({
            block: "start",
            inline: "nearest"
          });

          setTimeout(() => {
            document.body.style.overflow = '';
            this.openLoadingModal = false;
            this.selectedTransferEvent(this.selectedModality, this.selectedIndex);
          }, 1000);
        }

      } else if (this.currentStep == 2) {

        const outwardFA = this.bookingForm.get('outward') as FormArray;
        const returnFA = this.bookingForm.get('return') as FormArray;

        outwardFA?.markAllAsTouched();
        returnFA?.markAllAsTouched();
        this.bookingForm.markAllAsTouched();

        outwardFA?.updateValueAndValidity({ onlySelf: false, emitEvent: false });
        returnFA?.updateValueAndValidity({ onlySelf: false, emitEvent: false });
        this.bookingForm.updateValueAndValidity({ onlySelf: false, emitEvent: false });

        const legsInvalid = (outwardFA?.invalid ?? false) || (returnFA?.invalid ?? false);

        if (this.bookingForm.invalid || legsInvalid) {
          return;
        }

        this.currentStep = 3;

        this.loadingModalText = this.translateService.instant('product.almostDone');
        this.openLoadingModal = true;
        document.body.style.overflow = 'hidden';

        this.shadowRoot.getElementById("booking").scrollIntoView({
          block: "start",
          inline: "nearest"
        });

        this.preBooking();

      } else if (this.currentStep == 3) {
        // Abre modal antes
        this.loadingModalText = this.translateService.instant('product.almostDone');
        this.openLoadingModal = true;
        document.body.style.overflow = 'hidden';

        const ok = await this.handleSubmit(e);
        if (!ok) {
          // si falla, cierra modal
          this.openLoadingModal = false;
          document.body.style.overflow = '';
          return;
        }
      }

    }, 1000);
  }

  scrollNextStep(elementId: string): void {
    setTimeout(() => {
      this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
      const element = this.shadowRoot.querySelector('#' + elementId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.warn(`Element with ID "${elementId}" not found.`);
      }
    }, 100);
  }

  changeVisibility() {
    const hasPickup = this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.hasPickup;
    if (this.visibility && hasPickup) {
      // Mover el elemento y quitar el atributo 'hidden'
      this.renderer.setStyle(this.visibility.nativeElement, 'height', 'auto');
    } else if (!hasPickup) {
      this.currentStep++;
    }
  }

  getTotalPrice() {
    let basePrice = this.selectedModality.base_price.value.toFixed(2);
    let extraPrice = this.addOnsTotal.toFixed(2);
    this.totalPriceCost = (parseFloat(basePrice) + parseFloat(extraPrice)).toFixed(2);
    let totalPrice = this.calculatePVP(parseFloat(basePrice) + parseFloat(extraPrice));
    this.totalPVD = this.calculatePVD(totalPrice, 1, (parseFloat(basePrice) + parseFloat(extraPrice)));
    return totalPrice.toFixed(2);
  }

  calculatePVP(cost: any) {
    return this.rounded(1 * (this.pricing.markup ? ((cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= (cost * 1.20) ? (cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : (cost * 1.20)) : (cost * 1.20)))
  }

  calculatePVD(price: any, quantity: any, cost: any) {
    if (this.pricing) {

      switch (this.pricing.type) {
        case "NETOS": return (quantity * cost) / (1 - (this.pricing.markup / 100));
        case "REPARTO": return ((quantity * cost) + ((this.rounded((quantity * price)) - (quantity * cost)) * ((100 - this.pricing.percentage) / 100)));
        default: return (quantity * price) - ((quantity * price) * (this.pricing.percentage / 100));
      }
    } else {
      return 0
    }
  }

  rounded(price: any) {
    if (this.pricing.markup) {
      switch (this.pricing.roundedPrice.toLowerCase()) {
        case "up":
          return Math.ceil(price);
        case "down":
          return Math.floor(price);
        default:
          return parseFloat(price.toFixed(2));
      }
    } else {
      return price
    }
  }

  getDate() {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    // Format the date into Spanish using toLocaleDateString
    const formattedDate = this.bookingDates.start.toLocaleDateString(this.translateService.currentLang, options);
    if (this.booking.availableSchedule) {
      return [formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1), this.booking.availableSchedule.activitySchedule.startTime + 'h'];
    } else {
      return []
    }
  }

  preBooking() {
    // nuevo
    // console.log(this.bookingForm.get('locationDestination')?.value);

    const toBackendExtras = (extras: any[]) =>
      (extras || [])
        .map(x => ({ code: x.code, quantity: Number(x.quantity || 0) }))
        .filter(x => x.quantity > 0);

    let transfer_data: any = {
      quote_id: this.selectedTransfer.id,
      offer: {
        hash: this.modalities._metadata.offer.hash
      },
      customer: {
        title: this.bookingForm.get('pax')?.value[0].title,
        name: this.bookingForm.get('pax')?.value[0].name,
        surname: this.bookingForm.get('pax')?.value[0].surname,
        email: this.bookingForm.get('pax')?.value[0].email,
        mobile_country_code: this.bookingForm.get('pax')?.value[0].countryCode,
        mobile_phone: this.bookingForm.get('pax')?.value[0].phone,
      },
      lead_passenger: {
        title: this.bookingForm.get('pax')?.value[0].title,
        name: this.bookingForm.get('pax')?.value[0].name,
        surname: this.bookingForm.get('pax')?.value[0].surname,
        email: this.bookingForm.get('pax')?.value[0].email,
        mobile_country_code: this.bookingForm.get('pax')?.value[0].countryCode,
        mobile_phone: this.bookingForm.get('pax')?.value[0].phone,
      },
      gold_protection: this.bookingForm.get('gold_protection')?.value,
      sms_notification: this.bookingForm.get('sms')?.value,
      passengers: {
        total: this.getTotalPaxTransfer()
      },
      currency: "EUR",
      language: this.lang,
      transfers: [
        {
          outward: {
            [this.getTransferType((!this.invertedInputs ? this.selectedOrigin.subtype : this.bookingForm.get('locationDestination')?.value?.subtype))]: {
              ...(!this.invertedInputs ? this.outwardFA.getRawValue()[0].origin : this.returnFA.getRawValue()[0].origin)
            }
          },
          destination: {
            [this.getTransferType((!this.invertedInputs ? this.bookingForm.get('locationDestination')?.value?.subtype : this.selectedOrigin.subtype) || '')]: {
              ...(!this.invertedInputs ? this.outwardFA.getRawValue()[0].destination : this.returnFA.getRawValue()[0].destination)
            }
          },
          purchased_extras: toBackendExtras(this.outwardFA.value[0].extras)
        }
      ]
    }

    if (this.returnFA.getRawValue()[0] && (!this.invertedInputs || this.invertedInputs && this.endDateTimeISO)) {
      transfer_data.transfers.push({
        outward: {
          [this.getTransferType(!this.invertedInputs ? this.bookingForm.get('locationDestination')?.value.subtype : this.selectedOrigin.subtype || '')]: {
            ...(!this.invertedInputs ? this.returnFA.getRawValue()[0].origin : this.outwardFA.getRawValue()[0].origin)
          }
        },
        destination: {
          [this.getTransferType(!this.invertedInputs ? this.selectedOrigin.subtype || '' : this.bookingForm.get('locationDestination')?.value.subtype)]: {
            ...(!this.invertedInputs ? this.returnFA.getRawValue()[0].destination : this.outwardFA.getRawValue()[0].destination)
          }
        },
        purchased_extras: toBackendExtras(this.returnFA.value[0].extras)
      })
    }

    let childrens_info = this.genAges({ 'kids': parseInt(this.bookingForm.get('kids')?.value), 'infants': parseInt(this.bookingForm.get('infants')?.value) }, [this.selectedStartDate])

    if (childrens_info.length > 0) {
      transfer_data.passengers.children_info = childrens_info;
    }

    // this.mainService.postConnectionTransfers(this.connector, this.external_channel, 'bookings', transfer_data).subscribe((res: any) => {
    // Data to send to hub2b
    transfer_data.transfers[0].modality = this.selectedModality.vehicle.title;
    transfer_data.transfers[0].gold_protection = transfer_data.gold_protection;
    transfer_data.transfers[0].sms_notification = transfer_data.sms_notification;
    // transfer_data.transfers[0].pickupDate = res.transfers[0].pickup_date_time;
    // transfer_data.transfers[0].pickupMessage = res.transfers[0].pickup_instructions;
    transfer_data.transfers[0]['clientTypes'] = {};
    transfer_data.transfers[0]['clientTypes']['adults'] = { 'clientType': 'Adultos', 'quantity': this.bookingForm.get('adults')?.value };
    transfer_data.transfers[0]['clientTypes']['kids'] = { 'clientType': 'Niños', 'quantity': this.bookingForm.get('kids')?.value };
    transfer_data.transfers[0]['clientTypes']['infants'] = { 'clientType': 'Bebés', 'quantity': this.bookingForm.get('infants')?.value };
    if (transfer_data.transfers.length > 1) {
      transfer_data.transfers[1].modality = this.selectedModality.vehicle.title;
      transfer_data.transfers[1].gold_protection = transfer_data.gold_protection;
      transfer_data.transfers[1].sms_notification = transfer_data.sms_notification;
      // transfer_data.transfers[1].pickupDate = res.transfers[1].pickup_date_time;
      // transfer_data.transfers[1].pickupMessage = res.transfers[1].pickup_instructions;
      transfer_data.transfers[1]['clientTypes'] = {};
      transfer_data.transfers[1]['clientTypes']['adults'] = { 'clientType': 'Adultos', 'quantity': this.bookingForm.get('adults')?.value };
      transfer_data.transfers[1]['clientTypes']['kids'] = { 'clientType': 'Niños', 'quantity': this.bookingForm.get('kids')?.value };
      transfer_data.transfers[1]['clientTypes']['infants'] = { 'clientType': 'Bebés', 'quantity': this.bookingForm.get('infants')?.value };
    }
    let hub_data: any = {
      transfer: 1,
      seller: this.seller,
      email: this.bookingForm.get('pax')?.value[0].email,
      name: this.bookingForm.get('pax')?.value[0].name,
      hasAcceptance: true,
      observations: this.bookingForm.get('observations')?.value,
      paymentMethod: 'creditCard',
      promoCode: '',
      language: this.lang,
      totalPrice: this.getTotalPrice(),
      totalPriceCost: this.totalPriceCost,
      totalPVD: this.totalPVD,
      checkIn: this.selectedStartDate,
      checkOut: this.selectedEndDate ?? null,
      // externalSupplierLocator: res.reference,
      phone: this.bookingForm.get('pax')?.value[0].phone,
      data: transfer_data
      // data: transfer_data.transfers
    }

    this.mainService.post(this.api_url, 'transfer_integration_prebooking', hub_data).subscribe((transferBooking: any) => {
      this.bookingId = transferBooking.response.id;
      this.submitForm(transferBooking.response.id);
    }, (error: any) => {
      console.log(error);
    })
    // });
  }

  cashBooking() {
    this.mainService.post(this.api_url, 'activity_booking', { bookingId: this.bookingId, status: 'booked' }).subscribe(resp => {
      if (resp) {
        window.location.href = window.location.href.split('?')[0] + '/thank-you/' + this.bookingId
      }
    })
  }

  checkSellerCode(sellerCode: string) {
    if (this.api_url.split('.')[1] == this.external_channel) {
      this.mainService.getByParameter(this.api_url, 'code', sellerCode, 'sellers', 'es').subscribe(resp => {
        if (resp['hydra:member'].length == 1 && resp['hydra:member'][0].id == this.seller) {
          // If the seller code actually correlates to the seller the widget is expecting
          this.isValidSeller = true
        } else {
          this.isValidSeller = false
          this.showInvalidSellerError = true;
        }
      })
    } else {
      this.mainService.getConnectionEndpoint(this.external_channel, 'sellers?code=' + sellerCode, 'es').subscribe(resp => {
        if (resp['hydra:member'].length == 1 && resp['hydra:member'][0].id == this.seller) {
          // If the seller code actually correlates to the seller the widget is expecting
          this.isValidSeller = true
        } else {
          this.isValidSeller = false
          this.showInvalidSellerError = true;
        }
      })
    }
  }

  paymentElement: any;
  // Fetches a payment intent and captures the client secret
  async submitForm(bookingId: number) {
    if (!this.isOnRequest) {
      const response = await fetch(this.api_url + '/initialize_checkout/' + bookingId, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          "merchantAmount": (parseFloat(this.getTotalPrice().toString()) * 100).toString(),
          "merchantUrl": this.api_url + "/transfer_booking",
          "order": bookingId.toString(),
          // "DS_MERCHANT_PAYMETHODS": 'creditCard',
          "merchantUrlKo": this.error_url,
          "merchantUrlOk": this.success_url + bookingId
        })
      });

      const checkout = await response.json();

      if (checkout.type == 'stripe') {
        let clientSecret = checkout.clientSecret;
        this.elements = this.stripe.elements({ clientSecret });

        const paymentElementOptions = {
          layout: "tabs",
        };

        // Ensure we are mounting inside the Shadow DOM

        this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
        // this.shadowRoot = document.querySelector('payment-container')?.shadowRoot;
        if (!this.shadowRoot) {
          console.error("Shadow root not found!");
        }

        const paymentContainer = document.querySelector("#payment-element");
        const paymentContainerParent = document.querySelector("#payment-element-parent");
        const wc = document.querySelector("product-page-widget");
        const paymentExternalContainer = wc?.shadowRoot?.querySelector("#payment-external-element");
        const paymentExternalContainerParent = wc?.shadowRoot?.querySelector("#payment-external-element-parent");

        if (paymentContainer) {
          paymentContainerParent?.classList.add('show');
          this.paymentElement = this.elements.create("payment", paymentElementOptions);
          this.paymentElement.mount(paymentContainer)
        } else if (paymentExternalContainer) {
          paymentExternalContainerParent?.classList.add('show');
          const paymentExternalElement = this.elements.create("payment", paymentElementOptions);
          paymentExternalElement.mount(paymentExternalContainer)
        } else {
          console.error("Payment element container not found inside Shadow DOM!");
          return;
        }
        this.showPaymentForm = true; location.href.split('?')[0]
        setTimeout(() => {
          document.body.style.overflow = '';
          this.openLoadingModal = false;
        }, 1000);
      } else {
        var form = document.createElement("form");
        // form.target = "_self";
        form.method = "POST";
        form.action = checkout.redsysUrl;
        var params: any = {
          "Ds_SignatureVersion": "HMAC_SHA256_V1",
          "Ds_MerchantParameters": checkout.merchantParameters,
          "Ds_Signature": checkout.signature
        };
        for (var i in params) {
          if (params.hasOwnProperty(i)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
          }
        }

        document.body.appendChild(form);

        form.submit();
      }
    }
  }

  unmountStripe() {
    if (this.paymentElement) {
      this.paymentElement.unmount()
    }
  }

  async handleSubmit(e: any): Promise<boolean> {
    e.preventDefault();

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      // return_url: window.location.href.split('?')[0] + '/thank-you/' + this.bookingId,
      confirmParams: {
        return_url: window.location.href.split('?')[0] + 'thank-you/' + this.bookingId,
      },
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        this.showMessage(error.message);
      } else {
        this.showMessage("An unexpected error occurred.");
      }

      return false;
    }

    return true;
  }

  // ------- UI helpers -------

  public showMessage(messageText: any) {
    const messageContainer = document.querySelector("#payment-message");
    if (messageContainer) {
      messageContainer!.classList.remove("hidden");
      messageContainer!.textContent = messageText;

      setTimeout(function () {
        messageContainer!.classList.add("hidden");
        messageContainer!.textContent = "";
      }, 4000);
    }
  }

  // Show a spinner on payment submission
  setLoading(isLoading: any) {
    if (isLoading) {
      // Disable the button and show a spinner
      (this.shadowRoot.querySelector("#submit")! as HTMLButtonElement).disabled = true;
      this.shadowRoot.querySelector("#spinner")!.classList.remove("hidden");
      this.shadowRoot.querySelector("#button-text")!.classList.add("hidden");
    } else {
      (this.shadowRoot.querySelector("#submit")! as HTMLButtonElement).disabled = false;
      this.shadowRoot.querySelector("#spinner")!.classList.add("hidden");
      this.shadowRoot.querySelector("#button-text")!.classList.remove("hidden");
    }
  }

  getClosestPickupSchedule(pickupSchedules: any, latitude?: any, longitude?: any) {
    if (true) {
      // this.getUserLocation()
      //   .then((position: GeolocationPosition) => {
      //     const userLat = position.coords.latitude;
      if (latitude && longitude) {
        localStorage.setItem('userLat', latitude.toString());
        //     const userLon = position.coords.longitude;
        localStorage.setItem('userLon', longitude.toString());
        //Si hay coordenadas, añadimos el pickup mas cercano a la ubicación

        if (this.external_channel != "musement_pull") {
          this.closestPickupSchedule = this.findClosestPickupSchedule(pickupSchedules, latitude, longitude);
        } else {
          let pickupResponse = this.findPickupCandidates(pickupSchedules, latitude, longitude)
          this.pickupScheduleInRadious = pickupResponse.candidates
          this.closestPickupSchedule = pickupResponse.closest
          // console.log(this.pickupScheduleInRadious)
        }

      } else {
        //Si no hay coordenadas, añadimos el primer pickup de tipo isMeetingPoint
        this.closestPickupSchedule = pickupSchedules.find((pickupSchedule: any) => pickupSchedule.pickup?.isMeetingPoint === true);
      }

      if (this.closestPickupSchedule) {
        if (this.external_channel == "musement_pull") {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['code']);
          this.booking.pickup = this.closestPickupSchedule['pickup']
          this.booking.pickup['startTime'] = this.closestPickupSchedule['startTime']
          this.booking.pickup['maps'] = this.returnMapsCoordenates(this.closestPickupSchedule)
        } else {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['@id']);
          this.booking.pickup = { 'startTime': this.closestPickupSchedule.startTime, 'title': this.closestPickupSchedule.pickup.title, 'address': this.closestPickupSchedule.pickup.address, 'maps': this.returnMapsCoordenates(this.closestPickupSchedule), 'description': this.closestPickupSchedule.pickup.description, 'imageUrl': this.closestPickupSchedule.pickup.imageUrl, 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
          if (this.closestPickupSchedule.pickup.id) {
            this.booking.pickup['id'] = this.closestPickupSchedule.pickup.id
          }
        }
      }
      // })
      // .catch((err) => {
      //   this.error = 'Unable to retrieve your location: ' + err.message;
      // });
    } else {

      if (!this.closestPickupSchedule) {
        if (this.external_channel != "musement_pull") {
          this.closestPickupSchedule = this.findClosestPickupSchedule(pickupSchedules, localStorage.getItem('userLat'), localStorage.getItem('userLon'));
        } else {
          let pickupResponse = this.findPickupCandidates(pickupSchedules, localStorage.getItem('userLat'), localStorage.getItem('userLon'))
          this.pickupScheduleInRadious = pickupResponse.candidates
          this.closestPickupSchedule = pickupResponse.closest
          // console.log(this.pickupScheduleInRadious)
        }
      } else {
        if (this.external_channel != "musement_pull") {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['code']);
          this.booking.pickup = this.closestPickupSchedule['pickup']
          this.booking.pickup['startTime'] = this.closestPickupSchedule['startTime']
        } else {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule.pickup.id);
          this.booking.pickup = { 'startTime': this.closestPickupSchedule.startTime, 'title': this.closestPickupSchedule.pickup.title, 'address': this.closestPickupSchedule.pickup.address, 'maps': this.returnMapsCoordenates(this.closestPickupSchedule), 'description': this.closestPickupSchedule.pickup.description, 'imageUrl': this.closestPickupSchedule.pickup.imageUrl, 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
          if (this.closestPickupSchedule.pickup.id) {
            this.booking.pickup['id'] = this.closestPickupSchedule.pickup.id
          }
        }
      }
    }
  }

  getUserLocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject('Geolocation is not supported by this browser.');
      }
    });
  }

  // Convert degrees to radians
  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  // Calculate the distance between two lat/lon points using the Haversine formula
  private getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  }

  // Find the closest zone to the user's location
  findClosestPickupSchedule(pickupSchedules: any, userLat: any, userLon: any) {
    let closestPickupSchedule = null;
    pickupSchedules.forEach((pickupSchedule: any) => {
      const distance = this.getDistance(parseFloat(userLat), parseFloat(userLon), pickupSchedule.pickup.latitude, pickupSchedule.pickup.longitude);

      if (distance < this.closestDistance) {
        this.closestDistance = distance;
        closestPickupSchedule = pickupSchedule;
      } else if (this.closestDistance == distance) {
        closestPickupSchedule = pickupSchedule
      }
    });

    return closestPickupSchedule;
  }

  findPickupCandidates(
    pickupSchedules: any = [],
    userLat: any,
    userLon: any,
    opts: { radiusKm?: number; limit?: number } = {}
  ) {
    const { radiusKm = 2, limit = 20 } = opts;

    const lat = parseFloat(String(userLat));
    const lon = parseFloat(String(userLon));

    const withDist = pickupSchedules
      .map((ps: any) => {
        const lat2 = parseFloat(String(ps?.pickup?.latitude));
        const lon2 = parseFloat(String(ps?.pickup?.longitude));
        // ⚠️ Si tu getDistance devuelve METROS, usa:
        // const dKm = this.getDistance(lat, lon, lat2, lon2) / 1000;
        const dKm = this.getDistance(lat, lon, lat2, lon2);
        return Number.isFinite(dKm) ? { item: ps, _distanceKm: dKm } : null;
      })
      .filter((x: any): x is { item: any; _distanceKm: number } => !!x)
      .sort((a: any, b: any) => a._distanceKm - b._distanceKm || String(a.item?.pickup?.id).localeCompare(String(b.item?.pickup?.id)));

    const within = withDist.filter((x: any) => x._distanceKm <= radiusKm);
    const pool = within.length ? within : withDist;          // fallback a las más cercanas
    const top = pool.slice(0, limit);

    // Si quieres la distancia para debug/UI, cambia el map y devuelve {candidatesWithDistance: ...}
    return {
      closest: top[0]?.item ?? null,
      candidates: top.map((x: any) => x.item),
    };
  }

  cleanUbicationValue() {
    this.bookingForm.get('ubication')?.setValue('');
  }

  getClosestZone() {
    return;
    this.getUserLocation()
      .then((position: GeolocationPosition) => {
        const userLat = position.coords.latitude;
        localStorage.setItem('userLat', userLat.toString());
        const userLon = position.coords.longitude;
        localStorage.setItem('userLon', userLon.toString());

        const apiKey = 'AIzaSyDVebyjsQ7ANfVLQEh9IrGosdH-8H4tzFs'
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${userLat},${userLon}&key=${apiKey}`

        // Usando fetch para hacer la solicitud
        fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data.status === "OK") {
              const city = data.results[0].address_components.find((component: any) =>
                component.types.includes("locality")
              );
              const country = data.results[0].address_components.find((component: any) =>
                component.types.includes("administrative_area_level_1")
              );
              if (city) {
                this.bookingForm.get('ubication')?.setValue(city.long_name);
              } else if (country) {
                this.bookingForm.get('ubication')?.setValue(country.long_name);
              } else {
                this.bookingForm.get('ubication')?.setValue('My location in Mallorca');
              }
            } else {
              console.error("Error con la API de Google Geocoding: ", data.status);
            }
          })
          .catch(error => console.error("Error en la solicitud: ", error));
      })
      .catch((err) => {
        this.error = 'Unable to retrieve your location: ' + err.message;
      });
  }

  replacePForSpan(text: string): string {
    return text ? text.replace(/<p/g, '<span class="text"').replace(/<\/p/g, '</span') : '';
  }

  stripHTML(htmlString: string) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement.innerText;
  }

  showMoreText() {
    this.moreText = true;
  }

  openMap(maps: any) {
    window.open(maps, '_blank');
  }

  // In local environment working rarete
  isNextStep(index?: number) {
    switch (this.currentStep) {
      case 1:
        if (!this.bookingDates) {
          return true
        } else {
          return false
        }
      case 2:
        if (!this.resumeModality || ((Object.keys(this.booking.clientTypes).length == 0) || this.booking.clientTypes[Object.keys(this.booking.clientTypes)[0]].quantity == 0) || index != this.selectedIndex) {
          return true
        } else {
          return false
        }
      case 3:
        if (index != this.selectedIndex) {
          return true
        } else {
          return false
        }
      case 4:
        if (!this.bookingForm.valid) {
          return true
        } else {
          return false
        }
      default:
        return false
    }
  }

  showTooltip(event: MouseEvent) {
    this.isTooltipVisible = true;

    // Ajusta las coordenadas del tooltip dinámicamente
    this.tooltipPosition = {
      x: event.clientX - 250,
      y: event.clientY + 2
    };
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'ES' }
      }
    );

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place: any = autocomplete.getPlace();
      this.bookingForm.controls['ubication'].setValue(place.name)
      this.bookingForm.controls['locationDestination'].setValue(place.name)
      this.selectedPlaceAddress = place.formatted_address

      let latitude = place.geometry?.location?.lat().toString();
      let longitude = place.geometry?.location?.lng().toString();

      this.bookingForm.get('locationDestinationLatitude')?.setValue(latitude);
      this.bookingForm.get('locationDestinationLongitude')?.setValue(longitude);
      this.selectedLatitude = latitude
      this.selectedLongitude = longitude

      // Abrir calendario y scrollear
      this.showArrivalCalendar = true;
      setTimeout(() => {
        this.shadowRoot.getElementById("calendars").scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }, 0);
    });
    this.autocompleteFlag = true;
  }

  getPaxDetails() {
    this.loadingPaxDetails = true;
    this.booking['channelKey'] = this.external_channel;
    switch (this.external_channel) {
      case "globick_pull":
        const data = {
          productId: this.channelactivitycode,
          modalityId: this.booking.availableSchedule.id,
          startTime: this.booking.availableSchedule.activitySchedule.startTime
        };

        // Llamada al backend para obtener los campos
        this.mainService.getConnection(
          this.connector,
          this.external_channel,
          'paxdetails',
          this.booking,
          this.translateService.currentLang,
          this.channelactivitycode
        ).subscribe(result => {
          this.paxRules = result?.data;
          const numPax = this.getTotalPax();
          // this.pickups = result?.pickups;
          // console.log(this.pickups);


          this.clientTypeList = [];

          Object.entries(this.booking.clientTypes).forEach(([key, val]: any) => {
            const cantidad = Number(val.quantity) || 0;
            for (let i = 0; i < cantidad; i++) {
              this.clientTypeList.push(val.title as string); // o val.clientType si prefieres
            }
          });

          this.setPaxForms(this.paxRules, numPax);
        });
        break;
      case "musement_pull":

        // Llamada al backend para obtener los campos
        this.mainService.getConnection(
          this.connector,
          this.external_channel,
          'paxdetails',
          this.booking,
          this.translateService.currentLang,
          this.channelactivitycode,
        ).subscribe(result => {
          this.paxRules = result?.paxFormated;
          this.booking.cartId = result?.cartId;

          if (this.booking.pickup && result?.pickup_time) {
            this.booking.pickup.startTime = result?.pickup_time
          }

          const numPax = this.getTotalPax();

          this.pickups = result?.pickups;

          this.clientTypeList = [];

          Object.entries(this.booking.clientTypes).forEach(([key, val]: any) => {
            const cantidad = Number(val.quantity) || 0;
            for (let i = 0; i < cantidad; i++) {
              this.clientTypeList.push(val.title as string); // o val.clientType si prefieres
            }
          });

          this.setPaxForms(this.paxRules, numPax);

        });
        break;
    }
  }

  getTotalPax(): number {
    const clientTypes = this.booking.clientTypes;
    let total = 0;

    Object.values(clientTypes).forEach((ct: any) => {
      total += Number(ct.quantity);
    });

    return total;
  }

  get paxFormArray(): FormArray {
    return this.bookingForm.get('pax') as FormArray;
  }

  syncFormFields(index: number) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    const grupo = formArray.at(index);

    if (!grupo) return;

    const firstNameCtrl = grupo.get('name');
    const lastNameCtrl = grupo.get('surname');
    const emailCtrl = grupo.get('email');
    const phoneCtrl = grupo.get('phone');
    const contactPhoneCtrl = this.bookingForm.get('phone');
    const globalNameCtrl = this.bookingForm.get('name');
    const globalEmailCtrl = this.bookingForm.get('email');

    const updateFullName = () => {
      const first = firstNameCtrl?.value || '';
      const last = lastNameCtrl?.value || '';
      const fullName = `${first} ${last}`.trim();

      if (globalNameCtrl) {
        globalNameCtrl.setValue(fullName, { emitEvent: false });
      }
    };

    if (firstNameCtrl && lastNameCtrl) {
      firstNameCtrl.valueChanges.subscribe(updateFullName);
      lastNameCtrl.valueChanges.subscribe(updateFullName);
    }

    emailCtrl?.valueChanges
      .subscribe(v => {
        if (globalEmailCtrl && globalEmailCtrl.value !== v) {
          globalEmailCtrl.setValue(v, { emitEvent: false });
        }
      });


    phoneCtrl?.valueChanges.subscribe((v: any) => {
      if (contactPhoneCtrl && contactPhoneCtrl.value !== v) {
        contactPhoneCtrl.setValue(v, { emitEvent: false });
      }
    });

  }

  setPaxForms(paxRules: any, cantidad: number) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    formArray.clear();
    this.paxControlList = [];

    this.tieneCamposAll = Object.values(paxRules).some(
      (field: any) => field.scope === 'ALL'
    );

    if (!this.tieneCamposAll) {
      cantidad = 1;
    }

    for (let i = 0; i < cantidad; i++) {
      const controls: any = {};

      if (i == 0) {
        // Campos base (puedes eliminarlos si ya vienen del back como campos ONCE)
        controls['name'] = [null, Validators.required];
        controls['phone'] = [null, Validators.required];
        controls['email'] = [null, [Validators.required, Validators.email]];
      }

      Object.entries(paxRules).forEach(([campo, config]: any) => {
        // 🔍 Detectar si es formato viejo o nuevo
        let scope = typeof config === 'string' ? config : config.scope;
        let isFirstPax = i === 0;

        if (scope === 'ALL' || (scope === 'ONCE' && isFirstPax)) {
          if (!controls[campo]) {
            // 👉 Opcional: puedes meter validadores según el tipo
            const validators = [];

            if (typeof config === 'object') {
              if (config.inputType === 'email') validators.push(Validators.email);
              if (campo === 'email' || config.required) validators.push(Validators.required);
            } else {
              // para los casos antiguos
              validators.push(Validators.required);
            }

            controls[campo] = [null, validators];
          }
        }
      });

      const grupo = this.fb.group(controls);
      formArray.push(grupo);

      this.paxControlList.push(
        Object.keys(grupo.controls).map(key => ({
          key,
          control: grupo.get(key)!,
          title: paxRules?.[key]?.title || "",
          itemId: paxRules?.[key]?.itemId || null
        }))
      );
    }

    // this.syncContactPhoneToPhoneNumber(0);
    // (this.paxFormArray.controls || []).forEach((_, i) => {
    //   this.syncFullNameFromFirstLastName(i);
    // });

    if (cantidad > 0) {
      const primerPax = formArray.at(0);

      ['name', 'phone', 'email'].forEach(campo => {
        const val = primerPax.get(campo)?.value || '';
        this.bookingForm.get(campo)?.setValue(val);

        primerPax.get(campo)?.valueChanges.subscribe(val =>
          this.bookingForm.get(campo)?.setValue(val, { emitEvent: false }));
      });
    }
    this.loadingPaxDetails = false;
  }

  actualizarExternalCodes(objViejo: any, objNuevo: any) {
    const nuevosPrecios = objNuevo.activitySchedule.activityPrices;

    Object.entries(objViejo.clientTypes).forEach(([key, tipoCliente]: any) => {
      const match = nuevosPrecios.find((p: any) => p.clientType.code === key);

      if (match) {
        tipoCliente.externalCode = match.id;
        tipoCliente.price = match.price;
        tipoCliente.priceCost = match.cost;
      }
    });

    return objViejo;
  }

  toInt(number: any) {
    return parseInt(number);
  }

  checkForShortDistances(distance: any) {
    if (parseFloat(distance) < 2) {
      return (parseFloat(distance) * 1000).toString() + 'm'
    }
    else {
      return distance + 'km'
    }
  }

  redondearEntero(numero: any) {
    return Math.round(parseInt(numero));
  }

  returnMapsCoordenates(pickupSchedule: any) {
    let userLat = localStorage.getItem('userLat');
    let userLon = localStorage.getItem('userLon');

    if (userLat && userLon) {
      return 'https://www.google.com/maps/dir/?api=1&origin=' + userLat + ',' + userLon + '&destination=' + pickupSchedule.pickup.latitude + ',' + pickupSchedule.pickup.longitude + '&travelmode=' + this.getTravelMode(userLat, userLon, pickupSchedule.pickup.latitude, pickupSchedule.pickup.longitude)
    } else {
      return 'https://maps.google.com/?q=' + pickupSchedule.pickup.latitude + ',' + pickupSchedule.pickup.longitude
    }
  }

  getTravelMode(startLat: string, startLon: string, endLat: string, endLon: string) {
    const earthRadius = 6371; // Earth Radius in km

    const lat1 = parseFloat(startLat);
    const lon1 = parseFloat(startLon);
    const lat2 = parseFloat(endLat);
    const lon2 = parseFloat(endLon);

    // Convert degrees to radians
    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.degreesToRadians(lat1)) * Math.cos(this.degreesToRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c; // Distance in km

    // Determine travel mode
    return distance > 1 ? 'driving' : 'walking';
  }

  degreesToRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  validateNumber(event: any) {
    event.target.value = event.target.value.replace(/[^0-9+]/g, ''); // Elimina letras
  }

  private injectBootstrap() {
    const shadowRoot = this.elementRef.nativeElement.shadowRoot;

    const csslink = document.createElement('link');
    csslink.rel = 'stylesheet';
    csslink.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
    csslink.crossOrigin = 'anonymous';

    // Asegurar que los estilos solo se inyectan dentro del Shadow DOM
    shadowRoot.appendChild(csslink);

    // Inyectar Google Fonts

    const fontUrl = "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Bricolage+Grotesque:wght@200;300;400;500;600;700;800&display=swap";

    if (!document.querySelector(`link[href="${fontUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrl;
      document.head.appendChild(link);
    }

    // Cargar el script de Google Maps si no está cargado
    if (!shadowRoot.querySelector('script#google-maps') && !document.querySelector('script#google-maps')) {
      const script = this.renderer.createElement('script');
      script.id = 'google-maps';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVebyjsQ7ANfVLQEh9IrGosdH-8H4tzFs&libraries=places&loading=async';
      script.defer = true; // Asegura que el script se ejecute después de la carga completa
      this.renderer.appendChild(shadowRoot, script);
    }
  }

  setColors(color: string, secondaryColor: string) {
    if (color) {
      document.documentElement.style.setProperty('--primary-color', color);
      document.documentElement.style.setProperty('--mdc-circular-progress-active-indicator-color', color);
      document.documentElement.style.setProperty('--secondary-color', this.lightenColor(color, 30));
      document.documentElement.style.setProperty('--fourth-color', this.lightenColor(color, 95));
    }
    if (secondaryColor) {
      document.documentElement.style.setProperty('--terciary-color', secondaryColor);
    }
  }

  lightenColor(hex: string, percentage: number): string {
    // Asegúrate de que el hexadecimal comienza con "#"
    if (hex[0] === '#') {
      hex = hex.slice(1);
    }

    // Convertir el hexadecimal a valores RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calcular cuánto se debe aclarar cada componente RGB
    r = Math.round(r + (255 - r) * (percentage / 100));
    g = Math.round(g + (255 - g) * (percentage / 100));
    b = Math.round(b + (255 - b) * (percentage / 100));

    // Convertir de nuevo los valores RGB a hexadecimal
    const newR = r.toString(16).padStart(2, '0');
    const newG = g.toString(16).padStart(2, '0');
    const newB = b.toString(16).padStart(2, '0');

    // Devolver el color hexadecimal aclarado
    return `#${newR}${newG}${newB}`;
  }

  toggleAccordion(accordion: string) {
    const shadowRoot = document.querySelector("app-booking-widget")?.shadowRoot;
    const element = shadowRoot?.getElementById(accordion);

    if (element?.classList.contains("show")) {
      element.classList.remove("show");
      element.classList.add("hide");
    } else {
      element?.classList.remove("hide");
      element?.classList.add("show");
    }

    if (!element) {
      console.error("Elemento no encontrado:", accordion);
    }
  }

  initOutwardControls() {
    this.outwardFA.controls.forEach((leg: any, i: any) => {
      const airlineOriginCtrl = leg.get('origin.airline_code');
      if (airlineOriginCtrl) {
        this.filteredOutwardAirlines$[i] = airlineOriginCtrl.valueChanges.pipe(
          startWith(''),
          debounceTime(120),
          map(value => typeof value === 'string' ? value : value?.toString() || ''),
          map(text => this.filterAirlines(text as any))
        );
      }
    });

    this.returnFA.controls.forEach((leg: any, i: any) => {
      const airlineReturnCtrl = leg.get('destination.airline_code');
      if (airlineReturnCtrl) {
        this.filteredReturnAirlines$[i] = airlineReturnCtrl.valueChanges.pipe(
          startWith(''),
          debounceTime(120),
          map(value => typeof value === 'string' ? value : value?.toString() || ''),
          map(text => this.filterAirlines(text as any))
        );
      }
    });
  }

  private filterAirlines(text: string): { name: string, iata: string }[] {
    const filterValue = text.toLowerCase();
    if (!filterValue) {
      return this.airlines;
    }

    return this.airlines.filter((airline: any) =>
      (airline.name && airline.name.toLowerCase().includes(filterValue)) ||
      (airline.iata && airline.iata.toLowerCase().includes(filterValue))
    );
  }

  setOutwardOriginAirlineCodeValue(
    legIndex: number,
    key: string,
    value: string,
    event?: MouseEvent
  ) {
    event?.stopPropagation(); // 👈 clave

    const control = this.outwardFA
      .at(legIndex)
      .get('origin')
      ?.get(key);

    if (control) {
      control.setValue(value);
    }

    this.showOutwardOriginAirlineCode = false; // 👈 cierras el desplegable
  }

  setOutwardDestinationAirlineCodeValue(legIndex: number, key: string, value: string) {
    const control = this.outwardFA.at(legIndex).get('destination')?.get(key);
    if (control) {
      control.setValue(value);
    }
  }
  setReturnOriginAirlineCodeValue(legIndex: number, key: string, value: string) {
    const control = this.returnFA.at(legIndex).get('origin')?.get(key);
    if (control) {
      control.setValue(value);
    }
  }
  setReturnDestinationAirlineCodeValue(legIndex: number, key: string, value: string) {
    const control = this.returnFA.at(legIndex).get('destination')?.get(key);
    if (control) {
      control.setValue(value);
    }
  }

  setLocationOriginValue(loc: any) {
    this.selectedOrigin = loc;
    this.bookingForm.get('locationOrigin')?.setValue(loc.id)
    this.bookingForm.get('locationOriginFormatted')?.setValue(loc.name, { emitEvent: false })
    this.showOriginAirport = false;

    requestAnimationFrame(() => {
      if (!this.addresstext?.nativeElement) return;
      const input = this.addresstext.nativeElement;
      const field = input.closest('mat-form-field') as HTMLElement;
      input.focus();
      if (field) {
        field.classList.add('mat-focused');
      }
    });
  }

  onShadowClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.id === 'locationOriginFormatted') {
      this.showOriginAirport = true;
      const inputEl = this.shadowRoot.getElementById('locationOriginFormatted') as HTMLInputElement;
      inputEl?.focus({ preventScroll: true });
    } else if (target.id === 'outwardOriginAirlineCode') {
      this.showOutwardOriginAirlineCode = true;
    } else if (target.id === 'outwardDestinationAirlineCode') {
      this.showOutwardDestinationAirlineCode = true;
    } else if (target.id === 'returnOriginAirlineCode') {
      this.showReturnOriginAirlineCode = true;
    } else if (target.id === 'returnDestinationAirlineCode') {
      this.showReturnDestinationAirlineCode = true;
    } else if (target.id === 'countryCode' || target.id === "countryCodeOption") {
      this.showCountryCodes = true;
      const inputEl = this.shadowRoot.getElementById('countryCode') as HTMLInputElement;
      inputEl?.focus({ preventScroll: true });
    } else if (target.id != 'locationOriginOption' &&
      target.id != 'locationOriginFormatted' &&
      target.id != 'outwardOriginAirlineCodeOption' &&
      target.id != 'outwardOriginAirlineCode' &&
      target.id != 'outwardDestinationAirlineCodeOption' &&
      target.id != 'outwardDestinationAirlineCode' &&
      target.id != 'returnOriginAirlineCodeOption' &&
      target.id != 'returnOriginAirlineCode' &&
      target.id != 'returnDestinationAirlineCodeOption' &&
      target.id != 'returnDestinationAirlineCode'
    ) {
      this.showCountryCodes = false;
      this.showOriginAirport = false;
      this.showOutwardOriginAirlineCode = false;
      this.showOutwardDestinationAirlineCode = false;
      this.showReturnOriginAirlineCode = false;
      this.showReturnDestinationAirlineCode = false;
    }
  }

  onCalendarStartDateChange(date: Date) {
    this.selectedStartHour = null;
    this.selectedStartMinute = null;
    this.selectedStartDate = date;
    // Si seleccionamos una nueva fecha de inicio, y la fecha de llegada es inferior , reseteamos la de llegada
    if (
      this.selectedEndDate &&
      this.selectedStartDate &&
      new Date(this.selectedEndDate).getTime() < new Date(this.selectedStartDate).getTime()
    ) {
      this.selectedEndDate = undefined;
    }

    this.rebuildEndCalendarMonths();

    setTimeout(() => {
      const el = this.startTimeEl?.nativeElement as HTMLElement | undefined;
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      el.focus?.({ preventScroll: true } as any);
      this.showStartHourList = true;
    }, 250);
  }

  onCalendarEndDateChange(date: Date) {
    this.selectedEndHour = null;
    this.selectedEndMinute = null;
    this.selectedEndDate = date;
    setTimeout(() => {
      const el = this.endTimeEl?.nativeElement as HTMLElement | undefined;
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      el.focus?.({ preventScroll: true } as any);
      this.showEndHourList = true;
    }, 250);
  }

  returnVechicleImageUrl(vehicleCode: string) {
    let baseUrl = this.translationUrl + 'assets/images/vehicles-images/'
    if ('ch36-ch37-ch38-ch39-ch40-ch41-ch42-ch43-ch44-ch45-ch46-ch47-ch48-ch49-ch50-ch51-ch52-ch53-ch54-ch55-ch59-ch60-ch61-ch70-ch71-ch84'.includes(vehicleCode)) {
      return baseUrl + "ch36-ch37-ch38-ch39-ch40-ch41-ch42-ch43-ch44-ch45-ch46-ch47-ch48-ch49-ch50-ch51-ch52-ch53-ch54-ch55-ch59-ch60-ch61-ch70-ch71-ch84.jpg"
    } else if ('citytx3-citytx4-citytx5-citytxb4-citytx6'.includes(vehicleCode)) {
      return baseUrl + "citytx3-citytx4-citytx5-citytxb4-citytx6.jpg"
    } else if ('citytxbig6'.includes(vehicleCode)) {
      return baseUrl + "citytxbig6.jpg"
    } else if ('expsh-expsh5-sh-sh10-shB'.includes(vehicleCode)) {
      return baseUrl + "expsh-expsh5-sh-sh10-shB.jpg"
    } else if ('mb9-mb10-mb11-mb12'.includes(vehicleCode)) {
      return baseUrl + "mb9-mb10-mb11-mb12.jpg"
    } else if ('mch13-mch14-mch15-mch16-mch17-mch18-mch19-mch20-mch21-mch22-mch23-mch24-mch25-mch26-mch27-mch28-mch29-mch30-mch31-mch32-mch33-mch34-mch35'.includes(vehicleCode)) {
      return baseUrl + "mch13-mch14-mch15-mch16-mch17-mch18-mch19-mch20-mch21-mch22-mch23-mch24-mch25-mch26-mch27-mch28-mch29-mch30-mch31-mch32-mch33-mch34-mch35.jpg"
    } else if ('mv2b-mv3b-mv5-lmmv5-TCmv5-mv6-lmmv6-TCmv6-mv7-lmmv7-mv8-lmmv8-TCmv8'.includes(vehicleCode)) {
      return baseUrl + "mv2b-mv3b-mv5-lmmv5-TCmv5-mv6-lmmv6-TCmv6-mv7-lmmv7-mv8-lmmv8-TCmv8.jpg"
    } else if ('premmb9-premmb10-premmb12-premmch14-premmch15-premmch16-premmch18-premmch20-premmch22-premmch31'.includes(vehicleCode)) {
      return baseUrl + "premmb9-premmb10-premmb12-premmch14-premmch15-premmch16-premmch18-premmch20-premmch22-premmch31.jpg"
    } else if ('premmv5-premmv6-premmv7-premmv8'.includes(vehicleCode)) {
      return baseUrl + "premmv5-premmv6-premmv7-premmv8.jpg"
    } else if ('premtx2-premtx3-premtx4'.includes(vehicleCode)) {
      return baseUrl + "premtx2-premtx3-premtx4.jpg"
    } else if ('tx1-tx2-tx3-lmtx3-TCtx3-tx4-lmtx4-lvtx4'.includes(vehicleCode)) {
      return baseUrl + "tx1-tx2-tx3-lmtx3-TCtx3-tx4-lmtx4-lvtx4.jpg"
    } else if ('viptx2-viptx3-viptx4'.includes(vehicleCode)) {
      return baseUrl + "viptx2-viptx3-viptx4.jpg"
    } else if ('wav2-wav3-wav4-wav5-wav6'.includes(vehicleCode)) {
      return baseUrl + "wav2-wav3-wav4-wav5-wav6.jpg"
    } else if ('wtxsh-wtx6-premwtx6'.includes(vehicleCode)) {
      return baseUrl + "wtxsh-wtx6-premwtx6.jpg"
    } else {
      return ''
    }
  }

  returnVechicleTitle(vehicle: any) {
    // modality.vehicle.code
    // Devuelve el título del transfer traducido en funcion del código del vehículo
    if ('ch36-ch37-ch38-ch39-ch40-ch41-ch42-ch43-ch44-ch45-ch46-ch47-ch48-ch49-ch50-ch51-ch52-ch53-ch54-ch55-ch59-ch60-ch61-ch70-ch71-ch84'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Autocar privado'
      } else {
        return 'Private Coach'
      }
    } else if ('citytx3-citytx4-citytx5-citytxb4-citytx6'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Taxi'
      } else {
        return 'City Taxi'
      }
    } else if ('citytxbig6'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Taxi grande'
      } else {
        return 'Big City Taxi'
      }
    } else if ('expsh-expsh5-sh-sh10-shB'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Shuttle exprés'
      } else {
        return 'Express Shuttle'
      }
    } else if ('mb9-mb10-mb11-mb12'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Minibús privado'
      } else {
        return 'Private Minibus'
      }
    } else if ('mch13-mch14-mch15-mch16-mch17-mch18-mch19-mch20-mch21-mch22-mch23-mch24-mch25-mch26-mch27-mch28-mch29-mch30-mch31-mch32-mch33-mch34-mch35'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Minibús privado'
      } else {
        return 'Private Minicoach'
      }
    } else if ('mv2b-mv3b-mv5-lmmv5-TCmv5-mv6-lmmv6-TCmv6-mv7-lmmv7-mv8-lmmv8-TCmv8'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Minivan privada'
      } else {
        return 'Private Minivan'
      }
    } else if ('premmb9-premmb10-premmb12-premmch14-premmch15-premmch16-premmch18-premmch20-premmch22-premmch31'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Minibus premium'
      } else {
        return 'Premium Minibus'
      }
    } else if ('premmv5-premmv6-premmv7-premmv8'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Minivan premium'
      } else {
        return 'Premium Minivan'
      }
    } else if ('premtx2-premtx3-premtx4'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Transfer premium'
      } else {
        return 'Premium Transfer'
      }
    } else if ('tx1-tx2-tx3-lmtx3-TCtx3-tx4-lmtx4-lvtx4'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Traslado privado'
      } else {
        return 'Private Transfer'
      }
    } else if ('viptx2-viptx3-viptx4'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Coche VIP'
      } else {
        return 'VIP Car'
      }
    } else if ('wav2-wav3-wav4-wav5-wav6'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Vehículo accesible para silla de ruedas'
      } else {
        return 'Wheelchair Accessible Vehicle'
      }
    } else if ('wtxsh-wtx6-premwtx6'.includes(vehicle.code)) {
      if (this.lang == 'es') {
        return 'Táxi acuático premium'
      } else {
        return 'Premium Water Taxi'
      }
    } else {
      return vehicle.title
    }
  }

  step1Logic(modality: any, i: any) {
    this.selectedIndex = i;
    this.selectedTransfer = modality;
    if (!this.selectedModality) {
      this.selectedModality = modality;
      this.totalServicesAddition = 0;
      this.setPaxFormTransfer()
    }
    if (this.selectedModality != modality) {
      this.selectedModality = modality;
      this.totalServicesAddition = 0;
      this.setPaxFormTransfer()
    }
  }

  openAddExtrasModalFunction() {
    this.openAddExtrasModal = true;
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0);
  }

  closeAddExtrasModalFunction(selection: boolean) {
    this.openAddExtrasModal = false;
    document.body.style.overflow = '';
    this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
    if (selection) {
      // Bring the user to its selected modality and open its extras dropdown
      this.shadowRoot.getElementById("modality-" + this.selectedIndex).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
      this.openedModalityIndex = this.selectedIndex;
      // this.setPaxFormTransfer()
    } else {
      // Next step
      this.loadingModalText = 'Procesando';
      this.openLoadingModal = true;
      document.body.style.overflow = 'hidden';
      this.shadowRoot.getElementById("booking").scrollIntoView({
        block: "start",
        inline: "nearest"
      });
      setTimeout(() => {
        document.body.style.overflow = '';
        this.openLoadingModal = false;
      }, 1000);
      // this.setPaxFormTransfer();
      this.selectedTransferEvent(this.selectedModality, this.selectedIndex)
    }
  }

  addExtraPriceToBase(basePrice: any, extraPrice: any) {
    return (parseFloat(basePrice) + parseFloat(extraPrice)).toFixed(2).toString();
  }

  openDetailsCollapsibleAction() {
    this.openDetailsCollapsible = true;
    document.body.style.overflow = 'hidden';
  }

  closeDetailsCollapsibleAction() {
    this.openDetailsCollapsible = false;
    document.body.style.overflow = '';
  }

  getTitleErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('title');

    if (control?.hasError('required')) {
      return this.translateService.instant('error.title');
    }

    return this.translateService.instant('error.invalidTitle');
  }

  getNameErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('name');

    if (control?.hasError('required')) {
      return this.translateService.instant('error.name');
    }
    if (control?.hasError('minlength')) {
      return this.translateService.instant('error.shortName');
    }
    if (control?.hasError('maxlength')) {
      return this.translateService.instant('error.longName');
    }

    return this.translateService.instant('error.invalidName');
  }

  getSurnameErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('surname');

    if (control?.hasError('required')) {
      return this.translateService.instant('error.lastName');
    }
    if (control?.hasError('minlength')) {
      return this.translateService.instant('error.shortLastName');
    }
    if (control?.hasError('maxlength')) {
      return this.translateService.instant('error.longLastName');
    }

    return this.translateService.instant('error.invalidLastName');
  }

  getPhoneErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('phone');

    if (control?.hasError('required')) {
      return this.translateService.instant('error.phone');
    }
    if (control?.hasError('minlength')) {
      return this.translateService.instant('error.shortPhone');
    }
    if (control?.hasError('maxlength')) {
      return this.translateService.instant('error.longPhone');
    }

    return this.translateService.instant('error.invalidPhone');
  }

  getCountryCodeErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('countryCode');
    if (control?.hasError('required')) {
      return this.translateService.instant('error.prefix');
    }

    return this.translateService.instant('error.invalidPrefix');
  }

  getEmailErrorMessage(index: number): string {
    const control = this.paxFormArray.at(index).get('email');

    if (control?.hasError('required')) {
      return this.translateService.instant('error.email');
    }
    if (control?.hasError('minlength')) {
      return this.translateService.instant('error.shortEmail');
    }
    if (control?.hasError('maxlength')) {
      return this.translateService.instant('error.longEmail');
    }

    return this.translateService.instant('error.invalidEmail');
  }

  // Devuelve el FormControl dinámicamente
  getOutwardOriginControl(legIndex: number, key: string) {
    return this.outwardFA.at(legIndex).get('origin')?.get(key);
  }

  getOutwardDestinationControl(legIndex: number, key: string) {
    return this.outwardFA.at(legIndex).get('destination')?.get(key);
  }

  getReturnOriginControl(legIndex: number, key: string) {
    return this.returnFA.at(legIndex).get('origin')?.get(key);
  }

  getReturnDestinationControl(legIndex: number, key: string) {
    return this.returnFA.at(legIndex).get('destination')?.get(key);
  }

  // Devuelve mensaje de error según los validators del control
  getErrorMessage(control: AbstractControl | null): string {
    if (!control) return '';

    if (control.hasError('required')) return this.translateService.instant('error.mandatory');
    if (control.hasError('minlength')) return this.translateService.instant('error.short');
    if (control.hasError('maxlength')) return this.translateService.instant('error.long');
    if (control.hasError('pattern')) return this.translateService.instant('error.format');
    if (control.hasError('email')) return this.translateService.instant('error.invalidEmail');

    return this.translateService.instant('error.invalid');
  }

  trackByName(country: any) {
    return country.name;
  }

  selectCountry(country: any, index: any) {
    this.paxFormArray.at(index).get('countryCode')?.setValue(country.alpha2);
    // this.bookingForm.get('countryCode')!.setValue(country.phone[0]);
    this.showCountryCodes = false;
  }

  onCountryInputChange(event: any) {
    const input = event.target as HTMLInputElement;
    const value = input?.value || '';

    const filterValue = value.toLowerCase().trim();

    if (!filterValue) {
      this.countriesToShow = [];
      this.showCountryCodes = false;
      return;
    }

    this.countriesToShow = this.countries
      .filter((c: any) =>
        c.phone[0].includes(filterValue) ||
        c.name.toLowerCase().startsWith(filterValue)
      )
      .slice(0, 20);

    this.showCountryCodes = this.countriesToShow.length > 0;
  }


  generateCalendarMonths(count: number) {
    const start = new Date(this.startDate);
    start.setDate(1);

    this.calendarMonths = [];
    for (let i = 0; i < count; i++) {
      const d = new Date(start);
      d.setMonth(start.getMonth() + i);
      this.calendarMonths.push(d);
    }

    this.rebuildEndCalendarMonths();
  }

  private rebuildEndCalendarMonths() {
    // Si no hay start elegido, la vuelta muestra lo mismo que ida
    if (!this.selectedStartDate) {
      this.endCalendarMonths = [...this.calendarMonths];
      return;
    }

    // Primer mes permitido para vuelta = mes de la fecha de inicio (día 1)
    const minMonth = new Date(this.selectedStartDate);
    minMonth.setDate(1);
    minMonth.setHours(0, 0, 0, 0);

    // Filtras todos los meses anteriores
    this.endCalendarMonths = this.calendarMonths.filter(m => m.getTime() >= minMonth.getTime());
  }

  scrollIntoView(id: string) {
    requestAnimationFrame(() => {
      const el = this.shadowRoot?.getElementById(id);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  private sameMonth(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
  }

  startShouldShowSelectionAsActiveFor(month: Date): boolean {
    const ref = this.selectedStartDate ?? new Date();
    return this.sameMonth(month, ref);
  }

  private formatHM(totalMin: number): string {
    const hh = String(Math.floor(totalMin / 60)).padStart(2, '0');
    const mm = String(totalMin % 60).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  get startMinTime(): string | null {
    if (!this.selectedStartDate) return null;

    if (!this.isToday(this.selectedStartDate)) return null;

    const now = new Date();
    let total = now.getHours() * 60 + now.getMinutes();

    // opcional: redondear hacia arriba al step (ej. 5 en 5)
    const step = 1; // o tu minuteStep real
    total = Math.ceil(total / step) * step;

    if (total > 1439) return null;
    return this.formatHM(total);
  }

  receiveTime(period: 'start' | 'end', time: string | null) {
    if (!time) {
      // vacío
      if (period === 'start') { this.selectedStartHour = ''; this.selectedStartMinute = ''; }
      else { this.selectedEndHour = ''; this.selectedEndMinute = ''; }
      return;
    }

    const [hh, mm] = time.split(':');
    if (period === 'start') {
      this.selectedStartHour = hh;
      this.selectedStartMinute = mm;
    } else {
      this.selectedEndHour = hh;
      this.selectedEndMinute = mm;
    }
  }

  endShouldShowSelectionAsActiveFor(month: Date): boolean {
    const ref = this.selectedEndDate ?? new Date();
    return this.sameMonth(month, ref);
  }

  decreaseAdults() {
    const control = this.bookingForm.get('adults');
    if (!control) return;

    const current = control.value ?? 1;
    control.setValue(Math.max(1, current - 1));
  }

  decreaseKids() {
    const control = this.bookingForm.get('kids');
    if (!control) return;

    const current = control.value ?? 1;
    control.setValue(Math.max(0, current - 1));
  }

  decreaseInfants() {
    const control = this.bookingForm.get('infants');
    if (!control) return;

    const current = control.value ?? 1;
    control.setValue(Math.max(0, current - 1));
  }

  translateExtras(extra: string) {
    switch (extra) {
      case 'golf_bag':
        if (this.lang == 'es') {
          return 'Bolsa de golf'
        } else {
          return 'Golf bag'
        }
      case 'skis':
        if (this.lang == 'es') {
          return 'Esquís'
        } else {
          return 'Skis'
        }
      case 'extra_bag':
        if (this.lang == 'es') {
          return 'Equipaje extra'
        } else {
          return 'Extra bag'
        }
      case 'child_booster_seat':
        if (this.lang == 'es') {
          return 'Silla para niños'
        } else {
          return 'Child booster seat'
        }
      case 'baby_seat':
        if (this.lang == 'es') {
          return 'Silla para bebé'
        } else {
          return 'Baby seat'
        }
      case 'wheelchair':
        if (this.lang == 'es') {
          return 'Silla de ruedas'
        } else {
          return 'Wheelchair'
        }
      case 'bicycle':
        if (this.lang == 'es') {
          return 'Bicicleta'
        } else {
          return 'Bicycle'
        }
      default:
        return extra;
    }
  }

  decReturnExtra(i: number) {
    const qCtrl = this.extrasReturnFA.at(i).get('quantity');
    if (!qCtrl) return;

    const q = qCtrl.value ?? 0;
    if (q <= 0) return;

    qCtrl.setValue(q - 1);
    this.totalServicesAddition--;
    this.getTotalPrice();
  }

  incReturnExtra(i: number) {
    const group = this.extrasReturnFA.at(i);
    const qCtrl = group.get('quantity');
    const maxCtrl = group.get('max');
    if (!qCtrl) return;

    const q = qCtrl.value ?? 0;
    const max = maxCtrl?.value ?? Infinity;
    if (q >= max) return;

    qCtrl.setValue(q + 1);
    this.totalServicesAddition++;
    this.getTotalPrice();
  }

  decDepartureExtra(i: number) {
    const group = this.extrasFA.at(i);
    const qCtrl = group.get('quantity');
    if (!qCtrl) return;

    const q = qCtrl.value ?? 0;
    if (q <= 0) return;

    qCtrl.setValue(q - 1);
    this.totalServicesAddition--;
    this.getTotalPrice();
  }

  incDepartureExtra(i: number) {
    const group = this.extrasFA.at(i);
    const qCtrl = group.get('quantity');
    const maxCtrl = group.get('max');
    if (!qCtrl) return;

    const q = qCtrl.value ?? 0;
    const max = maxCtrl?.value ?? Infinity;
    if (q >= max) return;

    qCtrl.setValue(q + 1);
    this.totalServicesAddition++;
    this.getTotalPrice();
  }

}